// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-08-27T21:38:01.750Z
// Property: High Ridge Apts. (ID: 6767906449165606)
// Collections: 27 amenities, 4 floorplans (live), 35 photos, 48 POIs, 1 reviews, 1 virtual tours, 6 office hours, 1 special offers (live)
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5767906449162419",
  "multihub_property_id": "6767906449165606",
  "property_external_id": "fjcvebr",
  "property_zillow_url": "https://www.zillow.com/b/high-ridge-el-paso-tx-5XmXDM/",
  "property_apartments_url": "https://www.apartments.com/high-ridge-apts-el-paso-tx/fjcvebr/",
  "property_google_business_url": "https://www.google.com/maps/place/High+Ridge+Apartments/data=!4m2!3m1!1s0x0:0x5ebbc8ca6ac7c341?sa=X&ved=2ahUKEwid_K_K-bySAxVgrYkEHSS7C-8Q_BJ6BAgVEAA&hl=en&gl=us",
  "property_linkedin_url": null,
  "property_hubspot_id": "8443218215",
  "property_crm_software": "Yardi RentCafe",
  "property_pm_software": "Yardi",
  "property_pm_info": null,
  "property_status": null,
  "property_slug": "high-ridge-apts.",
  "property_name": "High Ridge Apts.",
  "property_website_url": "https://www.caseusa.com/apartments/tx/el-paso/high-ridge/",
  "property_domain": null,
  "property_address": "9353 Viscount",
  "property_full_address": "9353 Viscount, El Paso, TX, 79925",
  "property_address_1": "9353 Viscount",
  "property_address_2": null,
  "property_address_city": "El Paso",
  "property_address_state": "TX",
  "property_address_zip_full": null,
  "property_address_zip": "79925",
  "property_address_country": "US",
  "property_address_county": "El Paso County",
  "property_neighborhood_address": "Stonehaven",
  "property_address_latitude": "31.7708",
  "property_address_longitude": "-106.3627",
  "property_email": "highridge@caseusa.com",
  "property_phone": "(915) 223-6677",
  "property_call_tracking_phone": "844-752-0802",
  "property_company_name": "Case & Associates",
  "property_company_url": "https://www.caseusa.com/",
  "agency_contacts": null,
  "property_type": "Apartments",
  "property_short_description": "Experience a vibrant lifestyle at High Ridge Apts. in sunny El Paso, Texas. Choose from spacious one- and two-bedroom floor plans, complete with modern amenities like a sparkling pool, fitness center, and picnic area. Your ideal home awaits—explore our availability or schedule a tour today! Prefer to explore on your own time? Self-guided tours are available.",
  "property_long_description": "Welcome to High Ridge Apartments, your ideal oasis in the heart of El Paso, Texas! Our beautifully designed community offers an array of thoughtfully crafted floor plans to suit your lifestyle, featuring spacious one-bedroom and two-bedroom options. Enjoy the comfort of modern living with our extensive selection of exceptional amenities. Take a refreshing dip in our sparkling pool, stay fit in our state-of-the-art fitness center, or unwind in the serene picnic area.\n\nAt High Ridge, convenience is paramount. Our on-site maintenance and property management teams are dedicated to ensuring your living experience is hassle-free. Enjoy 24-hour access, online services, and package delivery services tailored to your needs. Our community also boasts a business center, conference rooms, and corporate suites, making it perfect for both professionals and families.\n\nEach apartment is designed for comfort and functionality, featuring air conditioning, kitchen appliances including a microwave and dishwasher, and ample storage space with walk-in closets and built-in bookshelves. Many units include delightful balconies or patios for you to relax and take in the stunning views of El Paso. \n\nWith amenities like high-speed internet access, laundry facilities, and smoke-free living, you'll feel right at home! Don’t miss your chance to experience the High Ridge lifestyle. Find your new home today—browse our current availability or schedule a tour to see everything we have to offer! Your dream apartment awaits at High Ridge Apartments!",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165606/019dbbe7-7806-7029-9676-f52dbc3dd031.webp",
  "property_featured_image_media": {
    "alt_text": "Exterior view of apartment buildings with brick and tan siding, balconies, and parking area.",
    "public_id": "019dbbe7-7806-7029-9676-f52dbc3dd031",
    "storage_key": "property/6767906449165606/019dbbe7-7806-7029-9676-f52dbc3dd031.webp",
    "width": 1280,
    "height": 853
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "296",
  "property_year_built": "1983",
  "property_year_renovated": null,
  "property_walk_score": null,
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "96.28378378378379",
  "property_admin_fee": null,
  "property_application_fee": "75",
  "property_fees_deposit_info": null,
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "500",
  "property_pet_deposit": "0",
  "property_monthly_pet_rent": "30",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": "0",
  "property_pet_restrictions": "Contact Leasing Office for details",
  "property_pet_policy_description": "Pets Welcome - Contact Leasing Office for details",
  "property_petpolicy_info": null,
  "property_online_leasing_url": "https://highridgeapartmentselpaso.securecafe.com/onlineleasing/high-ridge-apts/floorplans.aspx",
  "property_resident_portal_url": "https://highridgeapartmentselpaso.securecafe.com/residentservices/high-ridge-apts/userlogin.aspx",
  "property_apply_now_url": "https://highridgeapartmentselpaso.securecafe.com/onlineleasing/high-ridge-apts/guestlogin.aspx",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165606/019cfb40-67ed-75cf-912a-f1cf70580c03.webp",
  "property_primary_logo_media": {
    "alt_text": "High Ridge Apartments logo.",
    "public_id": "019cfb40-67ed-75cf-912a-f1cf70580c03",
    "storage_key": "property/6767906449165606/019cfb40-67ed-75cf-912a-f1cf70580c03.webp",
    "width": 300,
    "height": 210
  },
  "property_secondary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165606/019cfb41-6bf0-76ce-9467-c7ae4e555e1c.webp",
  "property_secondary_logo_media": {
    "alt_text": "CASE & ASSOCIATES logo",
    "public_id": "019cfb41-6bf0-76ce-9467-c7ae4e555e1c",
    "storage_key": "property/6767906449165606/019cfb41-6bf0-76ce-9467-c7ae4e555e1c.webp",
    "width": 325,
    "height": 325
  },
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": null,
  "property_fav_icon_media": null,
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165606/019cfb41-86a5-752d-88f5-9f8d20161c4b.webp",
  "property_mono_white_logo_media": {
    "alt_text": "High Ridge Apartments logo with mountains.",
    "public_id": "019cfb41-86a5-752d-88f5-9f8d20161c4b",
    "storage_key": "property/6767906449165606/019cfb41-86a5-752d-88f5-9f8d20161c4b.webp",
    "width": 300,
    "height": 210
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165606/019cfb41-93d4-773c-8d1c-95cb015786d7.webp",
  "property_mono_black_logo_media": {
    "alt_text": "High Ridge Apartments logo",
    "public_id": "019cfb41-93d4-773c-8d1c-95cb015786d7",
    "storage_key": "property/6767906449165606/019cfb41-93d4-773c-8d1c-95cb015786d7.webp",
    "width": 300,
    "height": 210
  },
  "property_company_icon": null,
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162419/019cfb35-ce4c-7138-92b0-dd454c056e38.webp",
  "property_company_logo_media": {
    "alt_text": "Case & Associates logo",
    "public_id": "019cfb35-ce4c-7138-92b0-dd454c056e38",
    "storage_key": "company/5767906449162419/019cfb35-ce4c-7138-92b0-dd454c056e38.webp",
    "width": 640,
    "height": 256
  },
  "property_company_mono_black_logo": null,
  "property_company_mono_black_logo_media": null,
  "property_company_mono_white_logo": null,
  "property_company_mono_white_logo_media": null,
  "property_primary_color": "#3d3d3f",
  "property_secondary_color": "#a76252",
  "property_font_color": null,
  "property_color_4": null,
  "property_color_3": "#cac4b8",
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "1 - 2",
  "property_bedrooms_min": "1",
  "property_bedrooms_max": "2",
  "property_bathrooms_range": "1 - 2",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "2",
  "property_sqft_range": "646 - 943",
  "property_sqft_min": "646",
  "property_sqft_max": "943",
  "property_price_range": "1075 - 1410",
  "property_price_min": "1075",
  "property_price_max": "1410",
  "property_available_units": 10,
  "property_facebook_url": "https://www.facebook.com/valley.ridgeapts/",
  "property_instagram_url": "https://www.instagram.com/high_ridge_apartments/",
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJST0RsDxb54YRQcPHasrIu14",
  "property_youtube_url": null,
  "property_yelp_url": "https://www.yelp.com/search?find_desc=Apartments&find_loc=George+Dieter+Dr%2C+El+Paso",
  "property_tiktok_url": null,
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to High Ridge Apts.",
  "property_home_romance_title": "Embrace Serenity and Connection in Your New Apartment Home",
  "property_home_amenities_blurb": "Welcome to High Ridge Apts. in El Paso, where modern living meets exceptional comfort. Choose from stylish one and two-bedroom floor plans boasting large closets and cozy fireplaces. Enjoy 24-hour access to premium amenities like a sparkling pool, fitness center, and business center—all designed to elevate your lifestyle.",
  "property_home_floorplans_blurb": "At High Ridge Apts. in El Paso, Texas, your ideal living space awaits. Choose from our stylish one and two-bedroom floor plans designed for comfort and convenience. Embrace a vibrant lifestyle with community amenities that suit your needs. Browse our available apartment homes today and find the perfect fit for you!",
  "property_home_gallery_blurb": "At High Ridge Apts. in El Paso, Texas, indulge in modern living with spacious one and two-bedroom floor plans. Enjoy amenities like a fitness center, pool, and picnic area, all crafted for your comfort. Imagine a vibrant lifestyle complemented by professional management and easy access to major highways. Picture yourself living here!",
  "property_home_neighborhood_blurb": "Nestled in the heart of El Paso, High Ridge Apts. offers a unique blend of comfort and convenience. Whether you’re looking for a cozy one-bedroom or a spacious two-bedroom, our community is surrounded by local charm and vibrant hotspots. Uncover the delights waiting just beyond your door!",
  "property_home_reviews_blurb": "Nestled in the heart of El Paso, High Ridge Apartments offers a vibrant community perfect for couples and families alike. Residents praise the \"priceless views\" and \"professionally maintained\" grounds, while enjoying amenities like a 24-hour fitness center and inviting pool. Experience effortless living, just minutes from dining and shopping!",
  "property_neighborhood_blurb": "At High Ridge Apts. in El Paso, immerse yourself in a vibrant community surrounded by top-notch educational institutions like Burges High School and Eastwood Knolls Elementary. Our diverse floor plans, including one and two-bedroom options, perfectly complement an active lifestyle. See what's around our community and engage with local favorites!",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "At High Ridge Apts. in El Paso, experience modern living with exceptional amenities. Dive into refreshing pool days, energize in our fitness center, or unwind in your stylish one or two-bedroom home featuring walk-in closets and balconies. Elevate your lifestyle today amidst convenience and comfort—your perfect space awaits!",
  "property_applynow_blurb": "At High Ridge Apts. in El Paso, experience luxurious living with versatile one and two-bedroom floor plans. Enjoy top-notch amenities like a sparkling pool, state-of-the-art fitness center, and cozy picnic area. Elevate your lifestyle with convenient online services and a dedicated management team. Lease your dream home today!",
  "property_contactus_blurb": "At High Ridge Apartments in El Paso, Texas, finding your perfect home is effortless with spacious one and two-bedroom floor plans tailored to your lifestyle. Step into comfort and convenience today—our leasing team is ready to assist you with any questions you may have! ",
  "property_faqs_blurb": "At High Ridge Apts. in El Paso, Texas, we offer thoughtfully designed one and two-bedroom floor plans to suit your lifestyle. Have questions? Our FAQs page is your go-to resource for all things related to our vibrant community. Get the answers you need for a seamless living experience!",
  "property_floorplans_blurb": "At High Ridge Apts. in vibrant El Paso, Texas, our thoughtfully designed one and two-bedroom floor plans cater to your unique lifestyle. Bright, inviting spaces await you—perfect for relaxation and entertaining. Browse our available apartment homes and unlock your ideal living experience today!",
  "property_gallery_blurb": "At High Ridge Apts. in El Paso, Texas, picture yourself lounging by the sparkling pool or unwinding on your private balcony. With spacious one and two-bedroom floor plans, a state-of-the-art fitness center, and convenient online services, you'll find a vibrant community ready for your lifestyle. Let your dream home come alive!",
  "property_interactivemap_blurb": "At High Ridge Apts. in vibrant El Paso, Texas, finding your perfect home is effortless. Choose from spacious one or two-bedroom layouts and enjoy exceptional amenities like a refreshing pool, fitness center, and business facilities. Navigate your options with our interactive community map and start your journey to elevated living today!",
  "property_pets_blurb": "At High Ridge Apts. in vibrant El Paso, you'll find a welcoming home for both you and your furry friends. Nestled amidst stunning landscapes, our community offers modern amenities and a friendly atmosphere. Reach out to our leasing office for pet policy details and embrace a lifestyle full of comfort and joy!",
  "property_referafriend_blurb": "At High Ridge Apts. in El Paso, Texas, spacious one and two-bedroom floor plans invite comfort and connection. With a vibrant community atmosphere, great friends make great neighbors. Share the experience—refer a friend today and let them join you in enjoying the perfect blend of style and convenience!",
  "property_residentaccess_blurb": "At High Ridge Apts. in El Paso, Texas, our thoughtfully designed one and two-bedroom floor plans cater to your lifestyle needs. Seamlessly manage your home from anywhere — access the resident portal to pay rent, request maintenance, and connect with your community today! Your convenience awaits.",
  "property_reviews_blurb": "At High Ridge Apartments in El Paso, residents enjoy community living like no other. With stunning views, family-friendly amenities, and swift maintenance responses, you’ll feel at home in no time. As one resident puts it, living here is “a vacation every day” with a pool, fitness center, and a welcoming staff!",
  "property_created_at": "1753982384783",
  "property_scheduletour_blurb": "At High Ridge Apts. in El Paso, Texas, our thoughtfully designed one and two-bedroom floor plans cater to your unique lifestyle. Experience modern living with exceptional amenities and a vibrant community. Curious about resident experiences? Schedule a tour today and hear firsthand what makes High Ridge Apts. a place you'll love to call home!",
  "property_thankyou_blurb": "Thank you for your interest in High Ridge Apts. in beautiful El Paso, Texas! Whether you're seeking a cozy one-bedroom retreat or a spacious two-bedroom haven, our diverse floor plans cater to every lifestyle. A member of our team will reach out shortly to assist you in finding your perfect home.",
  "property_virtualtours_blurb": "At High Ridge Apts. in vibrant El Paso, Texas, your perfect home awaits. Choose from our thoughtfully designed one and two-bedroom floor plans tailored for your lifestyle. Interested in seeing more? Take a virtual tour of our welcoming community and stylish apartments for rent today!",
  "property_copyright": "2025 All Rights Reserved. High Ridge Apts.",
  "property_seo_title_home": "High Ridge Apts. | Apartments in El Paso, Texas",
  "property_seo_description_home": "Welcome to High Ridge Apts. in El Paso, where luxurious living meets unbeatable amenities. Dive into comfort with pools, fitness centers, and spacious layouts. Your new home awaits!",
  "property_seo_title_floorplans": "Floor Plans | 1 - 2 Apartments in El Paso, Texas",
  "property_seo_description_floorplans": "Find your ideal home at High Ridge Apts. in El Paso! View our unique one and two-bedroom floor plans crafted for comfort and style. Browse now!",
  "property_seo_title_amenities": "Amenities | El Paso, Texas Apartments for Rent",
  "property_seo_description_amenities": "Unwind at High Ridge Apts. in El Paso! From sparkling pools to innovative workspaces, enjoy stylish living with top-notch amenities. Your perfect home awaits!",
  "property_seo_title_gallery": "Gallery | Apartments in El Paso, Texas",
  "property_seo_description_gallery": "\"Picture your life at High Ridge Apts. in El Paso! Enjoy luxurious floor plans, top-notch amenities, and a vibrant community. Explore our photo gallery today!\"",
  "property_seo_title_virtualtours": "Virtual Tours | High Ridge Apts. Apartments",
  "property_seo_description_virtualtours": "Experience High Ridge Apts. in El Paso, TX! Take a virtual tour of our inviting one and two-bedroom apartments designed for comfort and style. See for yourself!",
  "property_seo_title_interactivemap": "Interactive Map | High Ridge Apts. Apartments",
  "property_seo_description_interactivemap": "Find your ideal home at High Ridge Apts. in El Paso! Use our interactive map to explore spacious floor plans, premium amenities, and your perfect fit today!",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in El Paso, Texas",
  "property_seo_description_neighborhood": "Experience El Paso's vibrant life at High Ridge Apts. Uncover local gems, favorite hangouts, and key attractions just steps from your new home.",
  "property_seo_title_contact": "Contact Us | High Ridge Apts.",
  "property_seo_description_contact": "Experience modern living at High Ridge Apts. in El Paso! Choose from stunning one and two-bedroom floor plans. Reach out to our team with your questions today!",
  "property_seo_title_faqs": "FAQs | Apartments in El Paso, Texas",
  "property_seo_description_faqs": "Get the answers you need about life at High Ridge Apts. in El Paso! From floor plans to amenities, our FAQs page has you covered. Dive in today!",
  "property_seo_title_reviews": "Resident Reviews | Apartments in El Paso, Texas",
  "property_seo_description_reviews": "\"At High Ridge Apts. in El Paso, Texas, enjoy spacious one & two-bedroom homes with top-notch amenities. See what our residents love about life here!\"",
  "property_seo_title_applynow": "Apply Now | Apartments in El Paso, Texas",
  "property_seo_description_applynow": "Unwind at High Ridge Apts. in El Paso, TX. Offering stylish one and two-bedroom homes with luxurious amenities. Lease online and start your new chapter today!",
  "property_seo_title_residentaccess": "Resident Access | High Ridge Apts.",
  "property_seo_description_residentaccess": "\"Welcome to High Ridge Apts. in El Paso! Log in to manage your account, pay rent, and schedule maintenance—all from the comfort of home!\"",
  "property_seo_title_referafriend": "Refer A Friend | High Ridge Apts.",
  "property_seo_description_referafriend": "\"Great friends make great neighbors! Refer a friend to High Ridge Apts in El Paso and enjoy our vibrant community together. Start building memories today!\"",
  "property_seo_title_scheduletour": "Schedule a Tour | High Ridge Apts.",
  "property_seo_description_scheduletour": "Experience vibrant living at High Ridge Apts. in El Paso! Schedule a tour today and envision your new home where comfort meets convenience.",
  "property_seo_title_privacy": "Privacy Policy | High Ridge Apts.",
  "property_seo_description_privacy": "Your privacy matters at High Ridge Apts. in El Paso. Learn how we protect your information and commitment to your security. View our privacy policy today!",
  "property_seo_title_accessibility": "Website Accessibility | High Ridge Apts.",
  "property_seo_description_accessibility": "Elevate your experience at High Ridge Apts. in El Paso! We prioritize accessibility for all—ensuring everyone's comfort in our vibrant community. Join us!",
  "property_seo_title_sitemap": "Sitemap | High Ridge Apts.",
  "property_seo_description_sitemap": "Uncover the layout of High Ridge Apts. in El Paso! Navigate our sitemap for a seamless apartment journey and find your perfect home today.",
  "property_seo_title_thankyou": "Thank You | High Ridge Apts.",
  "property_seo_description_thankyou": "Thank you for reaching out to High Ridge Apts. in El Paso! Our team will connect soon to help you find your perfect home amidst stunning desert views.",
  "property_seo_title_pets": "Pet Policy | Apartments in El Paso, Texas",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1787865252835",
  "amenities": [
    {
      "id": "ec_18157206813400804596409d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165606",
      "source": "yardi",
      "external_id": "127396624",
      "title": "Business Center",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_6a9f4a933ae65abda8cd98e3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165606",
      "source": "yardi",
      "external_id": "127396625",
      "title": "Fitness Center",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_422091d893932631eaf5cac3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165606",
      "source": "yardi",
      "external_id": "127396626",
      "title": "Laundry Facilities",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_46368a7ccd784d0f4f2c69ff",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165606",
      "source": "yardi",
      "external_id": "127396627",
      "title": "On-Site Maintenance",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_1a21eadaa56d629d9990f6f5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165606",
      "source": "yardi",
      "external_id": "127396628",
      "title": "Package Receiving",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_0086343c69cf776a604d9922",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165606",
      "source": "yardi",
      "external_id": "127396629",
      "title": "Pool",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_df16bc39040fe60822b05b36",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165606",
      "source": "yardi",
      "external_id": "127396630",
      "title": "flex. Payment Options Available",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_ba971aec37f8cbadb124aeb5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165606",
      "source": "yardi",
      "external_id": "127396631",
      "title": "Short Term Leases Available",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_1df417a7ea2b441cb51222ae",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165606",
      "source": "yardi",
      "external_id": "127396632",
      "title": "Electronic Payments Accepted",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_15c23dbb1e3fa1eb816bab18",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165606",
      "source": "yardi",
      "external_id": "127396633",
      "title": "Ideal Location Near Fort Bliss",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_82630034c53f4a572eab36cd",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165606",
      "source": "yardi",
      "external_id": "127396634",
      "title": "Easy Access to I-10",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_79e7d7005d2b5f30f9083558",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165606",
      "source": "yardi",
      "external_id": "127396635",
      "title": "Pet Friendly",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_5563d50285d86eec4cf5c52e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165606",
      "source": "yardi",
      "external_id": "128042505",
      "title": "AT&T",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_dd1d24b36d8a5fb03e3ae214",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165606",
      "source": "yardi",
      "external_id": "127396636",
      "title": "Corporate Apartments Available",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_aa4908717a57540ccb11bb26",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165606",
      "source": "yardi",
      "external_id": "127396623",
      "title": "Spanish Speaking Staff",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_524bffa52963d999c3df2cb3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165606",
      "source": "yardi",
      "external_id": "127398107",
      "title": "Carpeting",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_9300c537304e54860a214f96",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165606",
      "source": "yardi",
      "external_id": "127398108",
      "title": "Ceiling Fan",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_bf277f4a8d87f7a91f99a834",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165606",
      "source": "yardi",
      "external_id": "127398109",
      "title": "Disposal",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_48cd814380d215d88ec70da9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165606",
      "source": "yardi",
      "external_id": "127398110",
      "title": "Extra Storage",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_1301c0ec2e0d6377c6c203f7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165606",
      "source": "yardi",
      "external_id": "127398111",
      "title": "Fireplace",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_63a472553d950543b027a0b3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165606",
      "source": "yardi",
      "external_id": "127398112",
      "title": "Large Closets",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_f081700032f50390b9a612b1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165606",
      "source": "yardi",
      "external_id": "127398113",
      "title": "Fully Equipped Kitchen",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_1cdcee7ab29403675f1d35f0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165606",
      "source": "yardi",
      "external_id": "127398114",
      "title": "Upgraded Countertops, Cabinets and Light Fixtures",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_394f2358038a5a3248d2b2a2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165606",
      "source": "yardi",
      "external_id": "127398115",
      "title": "W/D Hookup",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_e4d89d3c6c6eaaf3beb7fd58",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165606",
      "source": "yardi",
      "external_id": "127398116",
      "title": "Walk-In Closets",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_d8582799a98fe1b68ee2bd9a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165606",
      "source": "yardi",
      "external_id": "127398117",
      "title": "Roommate Friendly Floorplans Available",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_63119ab04bc049dacfc918c1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165606",
      "source": "yardi",
      "external_id": "127398118",
      "title": "Get connected to super fast internet powered by AT&T",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "custom_ff66b0f4-1984-4481-8324-1168bc6d7d46",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165606",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165606/019db5ab-0774-73ed-8aa7-ac60657f0cdb.webp",
      "image_media": {
        "alt_text": "Exterior of an apartment building with brick and beige siding, featuring balconies and an external staircase.",
        "public_id": "019db5ab-0774-73ed-8aa7-ac60657f0cdb",
        "storage_key": "property/6767906449165606/019db5ab-0774-73ed-8aa7-ac60657f0cdb.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Community",
      "description": "View of the apartment building exterior, showcasing its multi-level design with balconies and an accessible external staircase.",
      "link": "",
      "alt_text": "Exterior of an apartment building with brick and beige siding, featuring balconies and an external staircase.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_975c4ac8-d111-45b7-b6dc-1c3d530e0d47",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165606",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165606/019db5aa-fac4-74b2-a093-ef51c629a8cd.webp",
      "image_media": {
        "alt_text": "Laundry room with multiple washers, dryers, and a folding table.",
        "public_id": "019db5aa-fac4-74b2-a093-ef51c629a8cd",
        "storage_key": "property/6767906449165606/019db5aa-fac4-74b2-a093-ef51c629a8cd.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Community",
      "description": "Convenient on-site laundry facilities equipped with modern washers and dryers, featuring a spacious folding area for resident use.",
      "link": "",
      "alt_text": "Laundry room with multiple washers, dryers, and a folding table.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_9dfaef47-2582-463b-b896-e4a661b413e9",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165606",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165606/019db5aa-ecba-754e-a3a5-6b8051c59ef4.webp",
      "image_media": {
        "alt_text": "Exterior view of brick apartment buildings with landscaping and a blue sky.",
        "public_id": "019db5aa-ecba-754e-a3a5-6b8051c59ef4",
        "storage_key": "property/6767906449165606/019db5aa-ecba-754e-a3a5-6b8051c59ef4.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Community",
      "description": "View of the exterior of apartment buildings, showcasing the brick facade and surrounding landscaping. Offers a glimpse into the community's outdoor spaces.",
      "link": "",
      "alt_text": "Exterior view of brick apartment buildings with landscaping and a blue sky.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_3644e345-bff1-406e-aab9-24c00745dfaf",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165606",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165606/019db5aa-f2e5-756e-b74b-412b6e7e1fbd.webp",
      "image_media": {
        "alt_text": "Laundry room with multiple washing machines and dryers.",
        "public_id": "019db5aa-f2e5-756e-b74b-412b6e7e1fbd",
        "storage_key": "property/6767906449165606/019db5aa-f2e5-756e-b74b-412b6e7e1fbd.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Community",
      "description": "On-site laundry facilities available for resident convenience, featuring multiple washers and dryers.",
      "link": "",
      "alt_text": "Laundry room with multiple washing machines and dryers.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_4bad11de-d9df-4199-9895-4542d973ac39",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165606",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165606/019db5aa-d901-7244-93f6-1ec87f8a4843.webp",
      "image_media": {
        "alt_text": "Empty walk-in closet with white walls and carpeted floor.",
        "public_id": "019db5aa-d901-7244-93f6-1ec87f8a4843",
        "storage_key": "property/6767906449165606/019db5aa-d901-7244-93f6-1ec87f8a4843.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious walk-in closet with ample shelving and hanging space, perfect for organizing your wardrobe.",
      "link": "",
      "alt_text": "Empty walk-in closet with white walls and carpeted floor.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_0b09da45-bc4e-41b5-8215-ef99cc7ebb71",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165606",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165606/019db5aa-dcd3-76c5-9561-4d4b215b39d5.webp",
      "image_media": {
        "alt_text": "Exterior of apartment building with brick and siding, showing walkways and staircases.",
        "public_id": "019db5aa-dcd3-76c5-9561-4d4b215b39d5",
        "storage_key": "property/6767906449165606/019db5aa-dcd3-76c5-9561-4d4b215b39d5.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Community",
      "description": "Exterior view of apartment buildings featuring a mix of brick and siding, with accessible walkways and staircases leading to the entrances.",
      "link": "",
      "alt_text": "Exterior of apartment building with brick and siding, showing walkways and staircases.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_52d7b3fd-30d6-44b4-b51d-ec1e36ea1103",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165606",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165606/019db5aa-d51a-74cb-b407-bc2eeaf2feee.webp",
      "image_media": {
        "alt_text": "Bathroom with vanity, toilet, and bathtub with shower curtain",
        "public_id": "019db5aa-d51a-74cb-b407-bc2eeaf2feee",
        "storage_key": "property/6767906449165606/019db5aa-d51a-74cb-b407-bc2eeaf2feee.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "Spacious bathroom featuring a wooden vanity with a countertop sink, a toilet, and a bathtub with a decorative shower curtain.",
      "link": "",
      "alt_text": "Bathroom with vanity, toilet, and bathtub with shower curtain",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_d302e38f-c8cd-4bb4-977e-3096f02779fe",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165606",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165606/019db5aa-d543-726c-9786-711401834c14.webp",
      "image_media": {
        "alt_text": "View from a balcony with a door to the right and overlooking trees and apartment buildings.",
        "public_id": "019db5aa-d543-726c-9786-711401834c14",
        "storage_key": "property/6767906449165606/019db5aa-d543-726c-9786-711401834c14.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "Enjoy fresh air and scenic views from your private balcony. This outdoor space offers a peaceful retreat and a great spot to relax and unwind.",
      "link": "",
      "alt_text": "View from a balcony with a door to the right and overlooking trees and apartment buildings.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_5f67ff12-66d6-41f7-a772-684c0a7bfd6a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165606",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165606/019db5aa-d30b-7438-8122-44fc8b9eaf1e.webp",
      "image_media": {
        "alt_text": "A bedroom with a dresser, mirror, bed, and ceiling fan.",
        "public_id": "019db5aa-d30b-7438-8122-44fc8b9eaf1e",
        "storage_key": "property/6767906449165606/019db5aa-d30b-7438-8122-44fc8b9eaf1e.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "Cozy bedroom featuring a rustic wooden dresser with a decorative mirror, a comfortable bed with plush pillows, and a ceiling fan for added comfort.",
      "link": "",
      "alt_text": "A bedroom with a dresser, mirror, bed, and ceiling fan.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_3e4d6148-5144-4a9f-b05a-de64ec711f6f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165606",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165606/019db5aa-d333-7193-8b54-31eb66827add.webp",
      "image_media": {
        "alt_text": "Bedroom with a wooden bed frame, white linens, and coral accents.",
        "public_id": "019db5aa-d333-7193-8b54-31eb66827add",
        "storage_key": "property/6767906449165606/019db5aa-d333-7193-8b54-31eb66827add.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "Spacious bedroom featuring a queen-size bed with a rustic wooden headboard, plush carpeting, and natural light streaming through the window.",
      "link": "",
      "alt_text": "Bedroom with a wooden bed frame, white linens, and coral accents.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_c93ef300-90aa-478d-aa9a-f8f851375627",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165606",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165606/019db5aa-d175-70fe-8455-62bf14b94ee4.webp",
      "image_media": {
        "alt_text": "Empty laundry room hookups",
        "public_id": "019db5aa-d175-70fe-8455-62bf14b94ee4",
        "storage_key": "property/6767906449165606/019db5aa-d175-70fe-8455-62bf14b94ee4.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "This is a dedicated laundry room space with hookups for a washer and dryer.",
      "link": "",
      "alt_text": "Empty laundry room hookups",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_9346edc6-bb90-49dc-9b8b-1eef55fe6dfd",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165606",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165606/019db5aa-ce33-7573-b935-4bfb7c1fdd89.webp",
      "image_media": {
        "alt_text": "Kitchen with white appliances, wood cabinets, and granite countertops.",
        "public_id": "019db5aa-ce33-7573-b935-4bfb7c1fdd89",
        "storage_key": "property/6767906449165606/019db5aa-ce33-7573-b935-4bfb7c1fdd89.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "Fully equipped kitchen featuring white appliances, ample cabinet space, and stylish countertops.",
      "link": "",
      "alt_text": "Kitchen with white appliances, wood cabinets, and granite countertops.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_daf9fbef-b2e9-409a-aa1c-a06835a419b6",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165606",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165606/019db5aa-bdbc-7263-b224-c18946626c3e.webp",
      "image_media": {
        "alt_text": "Dining area with a round table, four chairs, and a cactus.",
        "public_id": "019db5aa-bdbc-7263-b224-c18946626c3e",
        "storage_key": "property/6767906449165606/019db5aa-bdbc-7263-b224-c18946626c3e.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "Enjoy meals in this charming dining area, perfect for intimate gatherings or casual dinners.",
      "link": "",
      "alt_text": "Dining area with a round table, four chairs, and a cactus.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_075b0d6f-a94b-4d80-bcb8-acf0e43f7e80",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165606",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165606/019db5aa-bc8d-7689-b29c-2ee94a851153.webp",
      "image_media": {
        "alt_text": "Resort-style swimming pool and lounge area with palm trees and surrounding apartment buildings.",
        "public_id": "019db5aa-bc8d-7689-b29c-2ee94a851153",
        "storage_key": "property/6767906449165606/019db5aa-bc8d-7689-b29c-2ee94a851153.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Community",
      "description": "Enjoy a refreshing swim in our sparkling pool, surrounded by lush landscaping and comfortable lounge chairs. Perfect for relaxing or entertaining.",
      "link": "",
      "alt_text": "Resort-style swimming pool and lounge area with palm trees and surrounding apartment buildings.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_d881651c-fa43-4d2b-b8d8-cbcd4b979d9c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165606",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165606/019db5aa-b585-769c-8c5a-519699d61bf9.webp",
      "image_media": {
        "alt_text": "Modern kitchen with wooden cabinets, white appliances, and granite countertops.",
        "public_id": "019db5aa-b585-769c-8c5a-519699d61bf9",
        "storage_key": "property/6767906449165606/019db5aa-b585-769c-8c5a-519699d61bf9.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "Step into this charming apartment kitchen, featuring sleek wooden cabinetry, durable granite countertops, and modern white appliances. Perfect for your culinary adventures.",
      "link": "",
      "alt_text": "Modern kitchen with wooden cabinets, white appliances, and granite countertops.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_fef88f43-f41b-4813-b34f-3ff68026e1a6",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165606",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165606/019db5aa-b438-753b-8731-5dd15471a28b.webp",
      "image_media": {
        "alt_text": "Living room with a sofa, ottoman, bar area, and television.",
        "public_id": "019db5aa-b438-753b-8731-5dd15471a28b",
        "storage_key": "property/6767906449165606/019db5aa-b438-753b-8731-5dd15471a28b.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "Spacious living area featuring a comfortable sofa, decorative ottoman, built-in bar, and entertainment center with a large television.",
      "link": "",
      "alt_text": "Living room with a sofa, ottoman, bar area, and television.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_552249f4-62c1-415e-b1d4-8aa8cf704072",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165606",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165606/019db5aa-b52f-729a-8a03-73206ac201af.webp",
      "image_media": {
        "alt_text": "Living room with a gray sectional sofa, decorative wall baskets, and a built-in bar.",
        "public_id": "019db5aa-b52f-729a-8a03-73206ac201af",
        "storage_key": "property/6767906449165606/019db5aa-b52f-729a-8a03-73206ac201af.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "Stylish living room featuring a comfortable gray sectional sofa, a unique coffee table, and a well-equipped built-in bar area, perfect for entertaining.",
      "link": "",
      "alt_text": "Living room with a gray sectional sofa, decorative wall baskets, and a built-in bar.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_43908b57-b0c2-4bc3-ae14-35c9baa636e8",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165606",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165606/019db5aa-b4b3-728a-9e44-1d2cbe4c4275.webp",
      "image_media": {
        "alt_text": "Kitchen featuring dark wood cabinets, granite-style countertops, stainless steel sink, and white appliances.",
        "public_id": "019db5aa-b4b3-728a-9e44-1d2cbe4c4275",
        "storage_key": "property/6767906449165606/019db5aa-b4b3-728a-9e44-1d2cbe4c4275.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "A spacious and functional kitchen with ample cabinet storage, a double basin sink, and modern countertops. Perfect for preparing meals.",
      "link": "",
      "alt_text": "Kitchen featuring dark wood cabinets, granite-style countertops, stainless steel sink, and white appliances.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_954a0bd4-0782-485e-9293-982110494dc5",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165606",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165606/019db5aa-b2e8-71bf-8864-292c03a52c1d.webp",
      "image_media": {
        "alt_text": "Mailboxes",
        "public_id": "019db5aa-b2e8-71bf-8864-292c03a52c1d",
        "storage_key": "property/6767906449165606/019db5aa-b2e8-71bf-8864-292c03a52c1d.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Community",
      "description": "Secure mailboxes for residents.",
      "link": "",
      "alt_text": "Mailboxes",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_dee15e76-a546-4d6f-91a0-853b98588763",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165606",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165606/019db5aa-3de1-7474-9fbd-84449af5e9f3.webp",
      "image_media": {
        "alt_text": "Empty walk-in closet with shelves and a hanging rod.",
        "public_id": "019db5aa-3de1-7474-9fbd-84449af5e9f3",
        "storage_key": "property/6767906449165606/019db5aa-3de1-7474-9fbd-84449af5e9f3.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious walk-in closet featuring ample shelving and a built-in clothing rod, perfect for organizing your belongings.",
      "link": "",
      "alt_text": "Empty walk-in closet with shelves and a hanging rod.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_5c0ec740-cb0a-4c7f-8526-c897919ab79a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165606",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165606/019db5aa-4247-739d-99de-103c08b9cf66.webp",
      "image_media": {
        "alt_text": "Cozy bedroom with a dark wood sleigh bed, nightstand with lamp, and a plush armchair.",
        "public_id": "019db5aa-4247-739d-99de-103c08b9cf66",
        "storage_key": "property/6767906449165606/019db5aa-4247-739d-99de-103c08b9cf66.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "Relax in comfort in this charming bedroom featuring a stylish sleigh bed, a convenient nightstand with a lamp, and a cozy armchair by the window.",
      "link": "",
      "alt_text": "Cozy bedroom with a dark wood sleigh bed, nightstand with lamp, and a plush armchair.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_c9359423-c130-4080-b9e8-3592638ac1e2",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165606",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165606/019db5aa-334e-7038-8740-2c33574fbbba.webp",
      "image_media": {
        "alt_text": "Bathroom vanity with wood cabinets, a white sink, and a large mirror.",
        "public_id": "019db5aa-334e-7038-8740-2c33574fbbba",
        "storage_key": "property/6767906449165606/019db5aa-334e-7038-8740-2c33574fbbba.webp",
        "width": 2048,
        "height": 3072
      },
      "title": "Apartment",
      "description": "This apartment bathroom features a double vanity with wood-look cabinets, a white sink, and a spacious mirror. A bathtub and toilet are visible through the doorway.",
      "link": "",
      "alt_text": "Bathroom vanity with wood cabinets, a white sink, and a large mirror.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_f22698a5-873c-4200-8156-7bd73b6cf662",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165606",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165606/019db5aa-3e68-71ac-8250-c9b606991009.webp",
      "image_media": {
        "alt_text": "Bathroom with a tub, toilet, vanity, and mirror.",
        "public_id": "019db5aa-3e68-71ac-8250-c9b606991009",
        "storage_key": "property/6767906449165606/019db5aa-3e68-71ac-8250-c9b606991009.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "Enjoy the convenience of this well-appointed bathroom, featuring a bathtub/shower combination, toilet, and vanity with ample storage.",
      "link": "",
      "alt_text": "Bathroom with a tub, toilet, vanity, and mirror.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_c55d45d8-1452-47bc-a71a-e94b142386dd",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165606",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165606/019db5aa-2ccc-75f1-9e98-10c09c87666d.webp",
      "image_media": {
        "alt_text": "Bedroom with a queen-size bed, nightstand, and ceiling fan.",
        "public_id": "019db5aa-2ccc-75f1-9e98-10c09c87666d",
        "storage_key": "property/6767906449165606/019db5aa-2ccc-75f1-9e98-10c09c87666d.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "Cozy bedroom featuring a comfortable queen-size bed with decorative pillows, a stylish nightstand with a lamp, and a modern ceiling fan.",
      "link": "",
      "alt_text": "Bedroom with a queen-size bed, nightstand, and ceiling fan.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_e344f950-78e8-4168-b4ed-edc1bf4fc73a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165606",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165606/019db5aa-2963-73d8-8381-4329099ffe0e.webp",
      "image_media": {
        "alt_text": "View from a balcony overlooking a parking lot and apartment buildings.",
        "public_id": "019db5aa-2963-73d8-8381-4329099ffe0e",
        "storage_key": "property/6767906449165606/019db5aa-2963-73d8-8381-4329099ffe0e.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Community",
      "description": "Enjoy the outdoors from your private balcony with a view of the community grounds and nearby parking.",
      "link": "",
      "alt_text": "View from a balcony overlooking a parking lot and apartment buildings.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_f369d136-9075-4884-bfff-caec840f3e5a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165606",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165606/019db5aa-26cb-725e-ab80-c148796a2167.webp",
      "image_media": {
        "alt_text": "Kitchen with dual sink, countertops, cabinets, dishwasher, and refrigerator.",
        "public_id": "019db5aa-26cb-725e-ab80-c148796a2167",
        "storage_key": "property/6767906449165606/019db5aa-26cb-725e-ab80-c148796a2167.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "A bright and functional kitchen featuring a dual sink, ample counter space, wood-look cabinets, and a dishwasher. Perfect for everyday living.",
      "link": "",
      "alt_text": "Kitchen with dual sink, countertops, cabinets, dishwasher, and refrigerator.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_b5ffd588-6f2b-4119-af1c-e261c0221813",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165606",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165606/019db5aa-243d-7735-bbfc-db14974cdf93.webp",
      "image_media": {
        "alt_text": "Kitchen with wood cabinets, stainless steel sink, white appliances, and a window.",
        "public_id": "019db5aa-243d-7735-bbfc-db14974cdf93",
        "storage_key": "property/6767906449165606/019db5aa-243d-7735-bbfc-db14974cdf93.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "Spacious kitchen featuring wood cabinetry, a double sink, and ample counter space. Includes white appliances and a window for natural light.",
      "link": "",
      "alt_text": "Kitchen with wood cabinets, stainless steel sink, white appliances, and a window.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_61662c0a-133c-4df4-af3b-a8cf34da77f3",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165606",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165606/019db5aa-17fd-70bb-970d-f3a44ba8fbf7.webp",
      "image_media": {
        "alt_text": "Living room with fireplace and dining area, view into bedroom.",
        "public_id": "019db5aa-17fd-70bb-970d-f3a44ba8fbf7",
        "storage_key": "property/6767906449165606/019db5aa-17fd-70bb-970d-f3a44ba8fbf7.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "Cozy living area featuring a brick fireplace, comfortable seating, and a separate dining space. The bedroom is visible through an open doorway.",
      "link": "",
      "alt_text": "Living room with fireplace and dining area, view into bedroom.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_78deaf01-e435-4bba-bdfc-d404bd6c79d2",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165606",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165606/019db5aa-1bf0-772c-9251-f61ca7ae6d80.webp",
      "image_media": {
        "alt_text": "Living room with fireplace and sofa",
        "public_id": "019db5aa-1bf0-772c-9251-f61ca7ae6d80",
        "storage_key": "property/6767906449165606/019db5aa-1bf0-772c-9251-f61ca7ae6d80.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "Cozy living room featuring a brick fireplace, comfortable sofa, and coffee table, perfect for relaxing.",
      "link": "",
      "alt_text": "Living room with fireplace and sofa",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_566aa7e1-7523-481c-bc38-6ee9904dcee5",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165606",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165606/019db5aa-14d3-7173-b508-e99c05bf2a81.webp",
      "image_media": {
        "alt_text": "Dining room with a round table and four chairs, a fireplace, and a sliding glass door.",
        "public_id": "019db5aa-14d3-7173-b508-e99c05bf2a81",
        "storage_key": "property/6767906449165606/019db5aa-14d3-7173-b508-e99c05bf2a81.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "Enjoy elegant dining in this apartment's dedicated dining room, complete with a cozy fireplace and access to a private patio.",
      "link": "",
      "alt_text": "Dining room with a round table and four chairs, a fireplace, and a sliding glass door.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_1756be25-b48a-4a28-b0ba-682a0c21067d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165606",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165606/019db5a9-f473-7023-acd2-08f603f1f8d0.webp",
      "image_media": {
        "alt_text": "Apartment complex swimming pool with lounge chairs and palm trees.",
        "public_id": "019db5a9-f473-7023-acd2-08f603f1f8d0",
        "storage_key": "property/6767906449165606/019db5a9-f473-7023-acd2-08f603f1f8d0.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Community",
      "description": "Relax by the sparkling swimming pool at our apartment community. Enjoy the sunshine from a lounge chair or gather with friends at the poolside tables.",
      "link": "",
      "alt_text": "Apartment complex swimming pool with lounge chairs and palm trees.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_557ae634-54ed-4930-9a2e-5d79029aea29",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165606",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165606/019db5a9-e55b-731d-9145-b7e3883229cf.webp",
      "image_media": {
        "alt_text": "Swimming pool and hot tub with lounge chairs and palm trees",
        "public_id": "019db5a9-e55b-731d-9145-b7e3883229cf",
        "storage_key": "property/6767906449165606/019db5a9-e55b-731d-9145-b7e3883229cf.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Community",
      "description": "Enjoy a refreshing swim in our sparkling pool or relax in the soothing hot tub. Surrounded by lush landscaping and comfortable lounge chairs, it's the perfect oasis.",
      "link": "",
      "alt_text": "Swimming pool and hot tub with lounge chairs and palm trees",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_8e51af9c-ceca-4c0b-acbd-834038e61f2a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165606",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165606/019db5a9-dbf8-7738-8bf3-581c2ed8cdcc.webp",
      "image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and palm trees.",
        "public_id": "019db5a9-dbf8-7738-8bf3-581c2ed8cdcc",
        "storage_key": "property/6767906449165606/019db5a9-dbf8-7738-8bf3-581c2ed8cdcc.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling swimming pool, surrounded by lush landscaping and comfortable seating. Perfect for relaxing or entertaining.",
      "link": "",
      "alt_text": "Resort-style swimming pool with lounge chairs and palm trees.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_5fed3b3a-83b1-4d79-9032-65c2194dd625",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165606",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165606/019db5a9-dbea-70ff-8bbb-fc2abf74d54c.webp",
      "image_media": {
        "alt_text": "Mailroom with multiple banks of gray mailboxes",
        "public_id": "019db5a9-dbea-70ff-8bbb-fc2abf74d54c",
        "storage_key": "property/6767906449165606/019db5a9-dbea-70ff-8bbb-fc2abf74d54c.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Community",
      "description": "Secure and convenient mail delivery with our on-site mailroom, featuring multiple banks of individual mailboxes for residents.",
      "link": "",
      "alt_text": "Mailroom with multiple banks of gray mailboxes",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_c3c59fe4-c706-4772-8c4a-fe07fe99db29",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165606",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165606/019db5a9-dbe9-737a-983e-cb493a348e67.webp",
      "image_media": {
        "alt_text": "Gym with treadmills, elliptical machines, stationary bikes, and weight racks.",
        "public_id": "019db5a9-dbe9-737a-983e-cb493a348e67",
        "storage_key": "property/6767906449165606/019db5a9-dbe9-737a-983e-cb493a348e67.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Community",
      "description": "Stay active in our fully equipped fitness center, featuring a variety of cardio and strength training equipment.",
      "link": "",
      "alt_text": "Gym with treadmills, elliptical machines, stationary bikes, and weight racks.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_d9f088dd-b4b0-422f-92f6-d9ca0d58b8e4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165606",
      "source": "custom",
      "poi_name": "Teppanyaki Grill & Buffet",
      "poi_type": "Restaurants",
      "poi_address": "8300 Gtwy Blvd E, El Paso, TX 79907, USA",
      "poi_short_description": "Casual buffet restaurant with a wide variety of classic Chinese & Japanese dishes, including sushi.",
      "poi_long_description": "Diners say this buffet restaurant offers a huge selection of sushi, Chinese food, Mexican food, and American dishes, including a teppanyaki/Mongolian grill. They also highlight the friendly and attentive staff, the fresh and delicious food, and the reasonable price.\n\nSome reviews mention the restaurant can be crowded.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165606/019d2709-53f2-733b-af98-a436fa070618.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-53f2-733b-af98-a436fa070618",
        "storage_key": "property/6767906449165606/019d2709-53f2-733b-af98-a436fa070618.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://ocs.ink/Teppanyaki_MenuPrice",
      "poi_directions_map_url": "https://maps.google.com/?cid=4709443183176625985&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "teppanyaki-grill--buffet",
      "poi_latitude": "31.7408162",
      "poi_longitude": "-106.328057",
      "poi_miles_from_property": "3.2",
      "poi_walking_minutes": "1 hour 11 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 915-595-6980",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165606/019d2709-921d-7603-967b-82a241d61188.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-921d-7603-967b-82a241d61188",
        "storage_key": "property/6767906449165606/019d2709-921d-7603-967b-82a241d61188.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJlRseKF9D54YRQa8gl59NW0E",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "buffet_restaurant"
    },
    {
      "id": "custom_b48ff325-23c1-4622-bc46-5b4aba59aa68",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165606",
      "source": "custom",
      "poi_name": "L & J Cafe",
      "poi_type": "Restaurants",
      "poi_address": "3622 E Missouri Ave, El Paso, TX 79903, USA",
      "poi_short_description": "A local landmark dating back to 1927, this family-run eatery serves regional Mexican dishes & beers.",
      "poi_long_description": "People say this Mexican restaurant serves delicious green chicken enchiladas, chile rellenos, and a combination plate. They highlight the affordable prices and fun, lively atmosphere. They also like the friendly and attentive staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165606/019d2709-539a-750d-abee-d621c7377f06.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-539a-750d-abee-d621c7377f06",
        "storage_key": "property/6767906449165606/019d2709-539a-750d-abee-d621c7377f06.webp",
        "width": 800,
        "height": 533
      },
      "poi_business_url": "http://ljcafe.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=253529114313290020&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "l--j-cafe",
      "poi_latitude": "31.7795154",
      "poi_longitude": "-106.4497953",
      "poi_miles_from_property": "5.9",
      "poi_walking_minutes": "2 hours 10 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 915-566-8418",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165606/019d2709-921d-7603-967b-82a241d61188.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-921d-7603-967b-82a241d61188",
        "storage_key": "property/6767906449165606/019d2709-921d-7603-967b-82a241d61188.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJy58M-oRZ54YRJPHc3mK3hAM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mexican_restaurant"
    },
    {
      "id": "custom_f92bcb4a-f940-450a-a45c-d1b06f4a6b11",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165606",
      "source": "custom",
      "poi_name": "Texas Roadhouse",
      "poi_type": "Restaurants",
      "poi_address": "10729 Gateway Blvd W, El Paso, TX 79935, USA",
      "poi_short_description": "Lively chain steakhouse serving American fare with a Southwestern spin amid Texas-themed decor.",
      "poi_long_description": "People say this steakhouse serves delicious steaks, rolls, and drinks. They also highlight the friendly staff, attentive service, and reasonable prices.\n\nOther reviews mention the wait time can be long.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165606/019d2709-544b-7578-b61d-589a402a3ee1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-544b-7578-b61d-589a402a3ee1",
        "storage_key": "property/6767906449165606/019d2709-544b-7578-b61d-589a402a3ee1.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.texasroadhouse.com/locations/texas/el-paso-gateway-west-blvd?utm_source=listing&utm_medium=search",
      "poi_directions_map_url": "https://maps.google.com/?cid=7533061792699482454&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "texas-roadhouse",
      "poi_latitude": "31.7512399",
      "poi_longitude": "-106.3414628",
      "poi_miles_from_property": "2.2",
      "poi_walking_minutes": "48 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 915-591-7427",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165606/019d2709-921d-7603-967b-82a241d61188.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-921d-7603-967b-82a241d61188",
        "storage_key": "property/6767906449165606/019d2709-921d-7603-967b-82a241d61188.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJKd43xq1E54YRVoHr4MnPimg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "steak_house"
    },
    {
      "id": "custom_0ddaee04-79e4-416b-a16a-9a9d0fd7bbbd",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165606",
      "source": "custom",
      "poi_name": "Raising Cane's Chicken Fingers",
      "poi_type": "Restaurants",
      "poi_address": "8867 Gateway Blvd W, El Paso, TX 79925, USA",
      "poi_short_description": "Fast-food chain specializing in fried chicken fingers, crinkle-cut fries & Texas toast.",
      "poi_long_description": "People say this fast food restaurant serves delicious chicken fingers, fries, and toasted bread. They highlight the fast service and friendly staff. They also like the good value.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165606/019d2709-5887-7389-90c7-b68af747dce0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-5887-7389-90c7-b68af747dce0",
        "storage_key": "property/6767906449165606/019d2709-5887-7389-90c7-b68af747dce0.webp",
        "width": 720,
        "height": 720
      },
      "poi_business_url": "https://locations.raisingcanes.com/tx/el-paso/8867-gateway-blvd-w",
      "poi_directions_map_url": "https://maps.google.com/?cid=16715938771041208080&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "raising-canes-chicken-fingers",
      "poi_latitude": "31.771909",
      "poi_longitude": "-106.3763932",
      "poi_miles_from_property": "0.9",
      "poi_walking_minutes": "21 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 915-599-9118",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165606/019d2709-921d-7603-967b-82a241d61188.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-921d-7603-967b-82a241d61188",
        "storage_key": "property/6767906449165606/019d2709-921d-7603-967b-82a241d61188.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJV3aoIhpb54YREEcXV7_x-uc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fast_food_restaurant"
    },
    {
      "id": "custom_061d7be0-bdcb-47f1-9929-837364de0efa",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165606",
      "source": "custom",
      "poi_name": "Cielo Vista Mall",
      "poi_type": "Shopping & Retail",
      "poi_address": "8401 Gateway Blvd W, El Paso, TX 79925, USA",
      "poi_short_description": "Classy retail complex with 2 floors of department stores & specialty shops, plus a movie theater.",
      "poi_long_description": "People say this shopping center offers a wide variety of stores and is a great place to shop. They also highlight the clean and friendly atmosphere, and the good service.\n\nOther reviews mention the parking can be difficult.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165606/019d2709-59af-70dd-8a54-29f09a3af2f4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-59af-70dd-8a54-29f09a3af2f4",
        "storage_key": "property/6767906449165606/019d2709-59af-70dd-8a54-29f09a3af2f4.webp",
        "width": 1280,
        "height": 598
      },
      "poi_business_url": "https://www.simon.com/mall/cielo-vista",
      "poi_directions_map_url": "https://maps.google.com/?cid=11576646027705312160&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "cielo-vista-mall",
      "poi_latitude": "31.7750435",
      "poi_longitude": "-106.37921",
      "poi_miles_from_property": "1.1",
      "poi_walking_minutes": "25 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 915-779-7070",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165606/019d2709-9245-711c-8c0e-188827452ffa.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-9245-711c-8c0e-188827452ffa",
        "storage_key": "property/6767906449165606/019d2709-9245-711c-8c0e-188827452ffa.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJo5kkYlRa54YRoOPP-zmCqKA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_d42c822b-2f1f-4e29-954d-f2c80c213e9f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165606",
      "source": "custom",
      "poi_name": "El Paso Community College - Valle Verde Campus",
      "poi_type": "Education",
      "poi_address": "919 Hunter Dr, El Paso, TX 79915, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165606/019d2709-5f42-768b-8322-0961c243334f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-5f42-768b-8322-0961c243334f",
        "storage_key": "property/6767906449165606/019d2709-5f42-768b-8322-0961c243334f.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://epcc.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12932995833553831033&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "el-paso-community-college---valle-verde-campus",
      "poi_latitude": "31.7521673",
      "poi_longitude": "-106.3697966",
      "poi_miles_from_property": "1.7",
      "poi_walking_minutes": "36 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 915-831-3722",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165606/019d2709-9211-73a8-ad5b-faceb1fda7f1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-9211-73a8-ad5b-faceb1fda7f1",
        "storage_key": "property/6767906449165606/019d2709-9211-73a8-ad5b-faceb1fda7f1.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJG6fyDhhb54YReUSVTDA7e7M",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_4ee8feec-2115-4668-9c25-c3086ab7b332",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165606",
      "source": "custom",
      "poi_name": "El Paso Zoo and Botanical Gardens",
      "poi_type": "Entertainment",
      "poi_address": "Train Station, 4001 E Paisano Dr, El Paso, TX 79905, USA",
      "poi_short_description": "220 African, American & Asian species residing in facsimiles of natural habitats in a 35-acre park.",
      "poi_long_description": "Visitors say this zoo offers a wide variety of animals, including penguins, sea lions, giraffes, and wolves, with fun activities like a splash pad and playground for kids. They also highlight the friendly staff, clean facilities, and educational exhibits.\n\nSome reviews mention many exhibits can be closed for renovations.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165606/019d2709-656c-704f-b9d2-5061439e3726.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-656c-704f-b9d2-5061439e3726",
        "storage_key": "property/6767906449165606/019d2709-656c-704f-b9d2-5061439e3726.webp",
        "width": 1024,
        "height": 1280
      },
      "poi_business_url": "http://www.elpasozoo.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9154948632860338008&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "el-paso-zoo-and-botanical-gardens",
      "poi_latitude": "31.7690489",
      "poi_longitude": "-106.4448897",
      "poi_miles_from_property": "5.8",
      "poi_walking_minutes": "2 hours 8 mins",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 915-212-0966",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165606/019d2709-920b-7671-9c92-f0330c3ed8e3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-920b-7671-9c92-f0330c3ed8e3",
        "storage_key": "property/6767906449165606/019d2709-920b-7671-9c92-f0330c3ed8e3.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJN7ASQX5Z54YRWKeWzkbpDH8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "zoo"
    },
    {
      "id": "custom_7bc919a5-26ee-49ef-b936-c94fc1e31abb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165606",
      "source": "custom",
      "poi_name": "El Paso County Coliseum",
      "poi_type": "Entertainment",
      "poi_address": "4100 E Paisano Dr, El Paso, TX 79905, USA",
      "poi_short_description": "Venue known for its many concerts and events, including monster trucks and a Van Gogh exhibit.",
      "poi_long_description": "People say this arena hosts awesome events like wrestling, rock concerts, and hockey games. They also highlight the fun and exciting atmosphere, and the good memories made at events.\n\nOther reviews mention the infrastructure can be difficult.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165606/019d2709-67e6-73fb-bfbb-34e1fac403ac.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-67e6-73fb-bfbb-34e1fac403ac",
        "storage_key": "property/6767906449165606/019d2709-67e6-73fb-bfbb-34e1fac403ac.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://epcountycoliseum.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14120659578983158164&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "el-paso-county-coliseum",
      "poi_latitude": "31.766561",
      "poi_longitude": "-106.4432224",
      "poi_miles_from_property": "6",
      "poi_walking_minutes": "2 hours 11 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 915-534-4229",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165606/019d2709-920b-7671-9c92-f0330c3ed8e3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-920b-7671-9c92-f0330c3ed8e3",
        "storage_key": "property/6767906449165606/019d2709-920b-7671-9c92-f0330c3ed8e3.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ52jcy31Z54YRlBGClxKp9sM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "arena"
    },
    {
      "id": "custom_d8f803a5-0ea1-426f-b10c-f9d681c6e7d9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165606",
      "source": "custom",
      "poi_name": "Fort Bliss Museum",
      "poi_type": "Entertainment",
      "poi_address": "1735 Marshall Rd, Fort Bliss, TX 79906, USA",
      "poi_short_description": "Large, free museum with tanks, trucks and military displays, uniforms and artifacts documenting the history of Fort Bliss and the First Armored Division.",
      "poi_long_description": "People say this museum offers a large collection of tanks, artillery, and other military vehicles used by the US and other armies. They also highlight the opportunity to get up close to the vehicles and the informative posters with basic information.\n\nOther reviews mention the museum can be empty.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165606/019d2709-6bf2-74e6-b252-1bfa23741590.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-6bf2-74e6-b252-1bfa23741590",
        "storage_key": "property/6767906449165606/019d2709-6bf2-74e6-b252-1bfa23741590.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://home.army.mil/bliss/index.php/my-fort/all-services/fort-bliss-and-old-ironsides-museu",
      "poi_directions_map_url": "https://maps.google.com/?cid=7293167302618848693&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "fort-bliss-museum",
      "poi_latitude": "31.8218243",
      "poi_longitude": "-106.4285014",
      "poi_miles_from_property": "6.6",
      "poi_walking_minutes": "2 hours 27 mins",
      "poi_biking_minutes": "36 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 915-568-5412",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165606/019d2709-962f-75dc-9bcd-5518bb7d3977.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-962f-75dc-9bcd-5518bb7d3977",
        "storage_key": "property/6767906449165606/019d2709-962f-75dc-9bcd-5518bb7d3977.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJ1QxGxefF4IYRtR0XWAWJNmU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_e5c8fe77-c3ee-4e7c-b720-049ddf982b13",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165606",
      "source": "custom",
      "poi_name": "Lost Kingdom Water Park",
      "poi_type": "Entertainment",
      "poi_address": "6001 Hughey Dr, El Paso, TX 79925, USA",
      "poi_short_description": "Water park with cabanas, lounging areas, plus a lazy river and a climbing wall.",
      "poi_long_description": "People say this water park offers a variety of pools suitable for all ages, including a lazy river, kiddie area, and a large pool with varying depths. They also highlight the attentive lifeguards, friendly staff, and clean facilities.\n\nOther reviews mention the food can be pricey.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165606/019d2709-6b53-720a-a449-907b9d43875d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-6b53-720a-a449-907b9d43875d",
        "storage_key": "property/6767906449165606/019d2709-6b53-720a-a449-907b9d43875d.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "https://epwaterparks.com/lost-kingdom",
      "poi_directions_map_url": "https://maps.google.com/?cid=6079401926571752602&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "lost-kingdom-water-park",
      "poi_latitude": "31.7906268",
      "poi_longitude": "-106.4149103",
      "poi_miles_from_property": "3.8",
      "poi_walking_minutes": "1 hour 26 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 915-541-3700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165606/019d2709-920b-7671-9c92-f0330c3ed8e3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-920b-7671-9c92-f0330c3ed8e3",
        "storage_key": "property/6767906449165606/019d2709-920b-7671-9c92-f0330c3ed8e3.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJffNdBLFb54YRmnwimNdfXlQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "water_park"
    },
    {
      "id": "custom_7e65ba14-25b6-4222-a2e0-4cc13f212761",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165606",
      "source": "custom",
      "poi_name": "Joshua W. Soto Physical Fitness Center",
      "poi_type": "Health and Wellness",
      "poi_address": "20751 Constitution Ave, Fort Bliss, TX 79918, USA",
      "poi_short_description": "Gym featuring a basketball court and clean showers and equipment, as well as a track.",
      "poi_long_description": "People say this gym offers a wide variety of equipment, including free weights, cardio machines, and a large lifting area with squat racks, as well as amenities like basketball courts, a boxing/martial arts room, an indoor track, and a sauna. They highlight the gym is open 24 hours and is a great value, especially for military personnel. They also like the easy-going and dominating vibe.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165606/019d2709-6e49-7098-9405-5f0b114f81ae.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-6e49-7098-9405-5f0b114f81ae",
        "storage_key": "property/6767906449165606/019d2709-6e49-7098-9405-5f0b114f81ae.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://bliss.armymwr.com/programs/joshua-w-soto-physical-fitness-center",
      "poi_directions_map_url": "https://maps.google.com/?cid=9843518981860297653&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "joshua-w-soto-physical-fitness-center",
      "poi_latitude": "31.849859",
      "poi_longitude": "-106.3546891",
      "poi_miles_from_property": "8.2",
      "poi_walking_minutes": "3 hours 1 min",
      "poi_biking_minutes": "46 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 915-744-5788",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165606/019d2709-920b-7671-9c92-f0330c3ed8e3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-920b-7671-9c92-f0330c3ed8e3",
        "storage_key": "property/6767906449165606/019d2709-920b-7671-9c92-f0330c3ed8e3.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ-dhbjxhQ54YRtQuZXVw0m4g",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_ebfd5329-0ee3-4b55-b14e-a68216946e2c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165606",
      "source": "custom",
      "poi_name": "Planet Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "6375 Montana Ave, El Paso, TX 79925, USA",
      "poi_short_description": "Treadmill-equipped facility featuring a variety of exercise machines and free weights, plus showers.",
      "poi_long_description": "People say this gym offers a wide variety of cardio machines and well-maintained equipment. They also highlight the friendly and helpful staff, and the clean and welcoming environment.\n\nOther reviews mention the gym can be crowded.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165606/019d2709-7170-7014-a7b3-fa7c7463ec69.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-7170-7014-a7b3-fa7c7463ec69",
        "storage_key": "property/6767906449165606/019d2709-7170-7014-a7b3-fa7c7463ec69.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.planetfitness.com/gyms/el-paso-montana-tx?utm_medium=organic&utm_source=extnet",
      "poi_directions_map_url": "https://maps.google.com/?cid=12897887577583852119&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "planet-fitness",
      "poi_latitude": "31.7898711",
      "poi_longitude": "-106.4046699",
      "poi_miles_from_property": "3.1",
      "poi_walking_minutes": "1 hour 10 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 915-778-7867",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165606/019d2709-920b-7671-9c92-f0330c3ed8e3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-920b-7671-9c92-f0330c3ed8e3",
        "storage_key": "property/6767906449165606/019d2709-920b-7671-9c92-f0330c3ed8e3.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJsV_A0TFa54YRVxrPdmqA_rI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_2afd2a6e-36b2-4105-b334-46a72318fab6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165606",
      "source": "custom",
      "poi_name": "Crunch Fitness - El Paso Zaragoza",
      "poi_type": "Health and Wellness",
      "poi_address": "2060 N Zaragoza Rd, El Paso, TX 79938, USA",
      "poi_short_description": "",
      "poi_long_description": "People say this gym offers a wide variety of equipment and classes, and has a motivating atmosphere.\n\nOther reviews mention the gym can be crowded and parking can be difficult.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165606/019d2709-7118-704e-9551-78c98c9973e1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-7118-704e-9551-78c98c9973e1",
        "storage_key": "property/6767906449165606/019d2709-7118-704e-9551-78c98c9973e1.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.crunch.com/locations/el-paso-zaragoza",
      "poi_directions_map_url": "https://maps.google.com/?cid=4890488308138438886&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "crunch-fitness---el-paso-zaragoza",
      "poi_latitude": "31.7665388",
      "poi_longitude": "-106.2612729",
      "poi_miles_from_property": "7",
      "poi_walking_minutes": "2 hours 37 mins",
      "poi_biking_minutes": "39 mins",
      "poi_driving_minutes": "20 mins",
      "poi_business_phone": "+1 915-336-0250",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165606/019d2709-920b-7671-9c92-f0330c3ed8e3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-920b-7671-9c92-f0330c3ed8e3",
        "storage_key": "property/6767906449165606/019d2709-920b-7671-9c92-f0330c3ed8e3.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJMfvh2WRF54YR5vDKkDSB3kM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_4f523fcd-cc76-46d1-934a-2ffc7e1956ee",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165606",
      "source": "custom",
      "poi_name": "Powerhouse Gym",
      "poi_type": "Health and Wellness",
      "poi_address": "1840 Lee Trevino Dr Ste 100, El Paso, TX 79936, USA",
      "poi_short_description": "Spacious fitness center featuring a range of equipment, tanning services, and a juice bar.",
      "poi_long_description": "Gym goers say this fitness center offers a wide variety of gym equipment, cycling classes, and amenities including a sauna, daycare, and supplements. They also highlight the friendly and helpful staff, and the clean and welcoming environment.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165606/019d2709-723c-75fd-859d-365d7f335130.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-723c-75fd-859d-365d7f335130",
        "storage_key": "property/6767906449165606/019d2709-723c-75fd-859d-365d7f335130.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://powerhousegym915.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6635965948837574386&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "powerhouse-gym",
      "poi_latitude": "31.7659573",
      "poi_longitude": "-106.3174303",
      "poi_miles_from_property": "3.3",
      "poi_walking_minutes": "1 hour 16 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 915-525-8698",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165606/019d2709-920b-7671-9c92-f0330c3ed8e3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-920b-7671-9c92-f0330c3ed8e3",
        "storage_key": "property/6767906449165606/019d2709-920b-7671-9c92-f0330c3ed8e3.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJb1vRdAFF54YR8jYNIt-vF1w",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fitness_center"
    },
    {
      "id": "custom_5578e3c4-b6b1-4f59-96ed-0a54699b79e5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165606",
      "source": "custom",
      "poi_name": "Mitchell W. Stout Physical Fitness Center",
      "poi_type": "Health and Wellness",
      "poi_address": "2930 Cassidy Rd, Fort Bliss, TX 79916, USA",
      "poi_short_description": "Gym featuring weightlifting equipment and treadmills, plus an informal cafe.",
      "poi_long_description": "People say this gym has a good variety of equipment, including weights and cardio machines. They also highlight the staff can be nice.\n\nSome reviews mention the equipment can be broken.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165606/019d2709-738d-7566-8d75-0bc0d4d8c0af.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-738d-7566-8d75-0bc0d4d8c0af",
        "storage_key": "property/6767906449165606/019d2709-738d-7566-8d75-0bc0d4d8c0af.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://bliss.armymwr.com/programs/stout-physical-fitness-center",
      "poi_directions_map_url": "https://maps.google.com/?cid=1842470217454083497&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "mitchell-w-stout-physical-fitness-center",
      "poi_latitude": "31.8136567",
      "poi_longitude": "-106.4057176",
      "poi_miles_from_property": "6.3",
      "poi_walking_minutes": "2 hours 21 mins",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 915-568-3264",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165606/019d2709-920b-7671-9c92-f0330c3ed8e3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-920b-7671-9c92-f0330c3ed8e3",
        "storage_key": "property/6767906449165606/019d2709-920b-7671-9c92-f0330c3ed8e3.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJL0ZIfHBa54YRqV2WpObEkRk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_b969dc9d-704c-4fb7-8e1a-1df2dd8da9fa",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165606",
      "source": "custom",
      "poi_name": "Chuze Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "1430 Lee Trevino Dr, El Paso, TX 79936, USA",
      "poi_short_description": "",
      "poi_long_description": "People say this fitness center offers a wide variety of lifting machines, free weights, bars, and racks, and has a great vibe and energy.\n\nOther reviews mention the equipment can be broken and the gym can be crowded.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165606/019d2709-75e4-7437-949b-f9b764483282.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-75e4-7437-949b-f9b764483282",
        "storage_key": "property/6767906449165606/019d2709-75e4-7437-949b-f9b764483282.webp",
        "width": 1024,
        "height": 576
      },
      "poi_business_url": "https://chuzefitness.com/gym-locations/tx/el-paso-mega-lee-trevino/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8078410797069877127&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "chuze-fitness",
      "poi_latitude": "31.7463727",
      "poi_longitude": "-106.3173561",
      "poi_miles_from_property": "3.8",
      "poi_walking_minutes": "1 hour 25 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 915-593-3133",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165606/019d2709-920b-7671-9c92-f0330c3ed8e3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-920b-7671-9c92-f0330c3ed8e3",
        "storage_key": "property/6767906449165606/019d2709-920b-7671-9c92-f0330c3ed8e3.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJe6nW6-dF54YRh78HldFHHHA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fitness_center"
    },
    {
      "id": "custom_2705e670-4761-4bf1-94e5-4b798c9b626d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165606",
      "source": "custom",
      "poi_name": "Memorial Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1701 N Copia St, El Paso, TX 79930, USA",
      "poi_short_description": "Community park with trails, lighted softball field, tennis courts, playground & a swimming pool.",
      "poi_long_description": "People say this city park offers beautiful trees, grassy hills, and a playground. They highlight the clean and well-maintained landscape, and the peaceful and relaxing atmosphere. They also like the shade provided by the trees, making it a great spot for picnics and outdoor activities.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165606/019d2709-7b24-7122-b879-2f5ef82e900c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-7b24-7122-b879-2f5ef82e900c",
        "storage_key": "property/6767906449165606/019d2709-7b24-7122-b879-2f5ef82e900c.webp",
        "width": 1000,
        "height": 750
      },
      "poi_business_url": "http://www.elpasotexas.gov/parks-and-recreation",
      "poi_directions_map_url": "https://maps.google.com/?cid=615165719072263059&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "memorial-park",
      "poi_latitude": "31.7894065",
      "poi_longitude": "-106.4571558",
      "poi_miles_from_property": "6.5",
      "poi_walking_minutes": "2 hours 25 mins",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 915-212-0092",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165606/019d2709-9718-7529-99e8-96fa74102a98.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-9718-7529-99e8-96fa74102a98",
        "storage_key": "property/6767906449165606/019d2709-9718-7529-99e8-96fa74102a98.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ9_YWrJNZ54YRk8tMU_aBiQg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_park"
    },
    {
      "id": "custom_b337c145-d32f-4d9f-ab4d-d1d4f3d4d061",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165606",
      "source": "custom",
      "poi_name": "Marty Robbins Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "11620 Vista del Sol Dr, El Paso, TX 79936, USA",
      "poi_short_description": "Community park with a pool, sports fields, basketball courts, playground & restrooms.",
      "poi_long_description": "Community park with a pool, sports fields, basketball courts, playground & restrooms.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165606/019d2709-7f14-70d2-a6e5-0ce5d3f515fd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-7f14-70d2-a6e5-0ce5d3f515fd",
        "storage_key": "property/6767906449165606/019d2709-7f14-70d2-a6e5-0ce5d3f515fd.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.elpasotexas.gov/parks-and-recreation",
      "poi_directions_map_url": "https://maps.google.com/?cid=12814619974849682047&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "marty-robbins-park",
      "poi_latitude": "31.7497559",
      "poi_longitude": "-106.2969227",
      "poi_miles_from_property": "5.1",
      "poi_walking_minutes": "1 hour 54 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 915-212-0426",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165606/019d2709-9718-7529-99e8-96fa74102a98.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-9718-7529-99e8-96fa74102a98",
        "storage_key": "property/6767906449165606/019d2709-9718-7529-99e8-96fa74102a98.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ7RinpH9E54YRf1qK7Pis1rE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_park"
    },
    {
      "id": "custom_0cb526a1-7fd1-4056-9fce-f3ec15fad5a9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165606",
      "source": "custom",
      "poi_name": "Blackie Chesher Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1100 N Zaragoza Rd, El Paso, TX 79907, USA",
      "poi_short_description": "Sizable park featuring a playground, walking path & fields for soccer & baseball/softball.",
      "poi_long_description": "Sizable park featuring a playground, walking path & fields for soccer & baseball/softball.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165606/019d2709-7fea-7580-9edb-cdcebcea4850.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-7fea-7580-9edb-cdcebcea4850",
        "storage_key": "property/6767906449165606/019d2709-7fea-7580-9edb-cdcebcea4850.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.elpasotexas.gov/parks/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6374719998777487238&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "blackie-chesher-park",
      "poi_latitude": "31.714197",
      "poi_longitude": "-106.3056358",
      "poi_miles_from_property": "5.7",
      "poi_walking_minutes": "2 hours 5 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 915-212-0092",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165606/019d2709-9718-7529-99e8-96fa74102a98.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-9718-7529-99e8-96fa74102a98",
        "storage_key": "property/6767906449165606/019d2709-9718-7529-99e8-96fa74102a98.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJPRRclQ9D54YRhu-1bRCOd1g",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_59b8961f-e438-41d9-91e4-a94ef7f1bc7c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165606",
      "source": "custom",
      "poi_name": "El Paso International Airport",
      "poi_type": "Transportation & Transit",
      "poi_address": "6701 Convair Rd, El Paso, TX 79925, USA",
      "poi_short_description": "Established in 1928, this small airport offers free WiFi & a cell phone waiting lot.",
      "poi_long_description": "People say this airport is small, efficient, and easy to navigate, with short walking distances and quick security checks. They highlight the clean and well-organized facilities, and the convenient access to rental cars. They also like the friendly and helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165606/019d2709-834c-7208-999a-61bc9cb6ca26.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-834c-7208-999a-61bc9cb6ca26",
        "storage_key": "property/6767906449165606/019d2709-834c-7208-999a-61bc9cb6ca26.webp",
        "width": 1280,
        "height": 415
      },
      "poi_business_url": "http://www.elpasointernationalairport.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2247101600509703497&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "el-paso-international-airport",
      "poi_latitude": "31.8058228",
      "poi_longitude": "-106.3705379",
      "poi_miles_from_property": "6.9",
      "poi_walking_minutes": "2 hours 33 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 915-212-0330",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165606/019d2709-97b1-72ff-99ec-34c3d7d0ef43.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-97b1-72ff-99ec-34c3d7d0ef43",
        "storage_key": "property/6767906449165606/019d2709-97b1-72ff-99ec-34c3d7d0ef43.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJfQ9mvJNa54YRSbWXAABPLx8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "international_airport"
    },
    {
      "id": "custom_ead8d6ac-0af4-4267-a67c-9df89dc4cd25",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165606",
      "source": "custom",
      "poi_name": "Fort Bliss A/DACG",
      "poi_type": "Transportation & Transit",
      "poi_address": "Fort Bliss, TX 79918, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165606/019d2709-8397-742e-a802-425759202e5a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-8397-742e-a802-425759202e5a",
        "storage_key": "property/6767906449165606/019d2709-8397-742e-a802-425759202e5a.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "https://home.army.mil/hood/index.php/units-tenants/installation-transportation-office/arrivaldeparture-airfield-control-group-dacg",
      "poi_directions_map_url": "https://maps.google.com/?cid=10912390521258870755&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "fort-bliss-adacg",
      "poi_latitude": "31.8294155",
      "poi_longitude": "-106.4096364",
      "poi_miles_from_property": "7.4",
      "poi_walking_minutes": "2 hours 45 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 915-568-8300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165606/019d2709-97b1-72ff-99ec-34c3d7d0ef43.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-97b1-72ff-99ec-34c3d7d0ef43",
        "storage_key": "property/6767906449165606/019d2709-97b1-72ff-99ec-34c3d7d0ef43.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJjx8btptQ54YR44f53VyZcJc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "airport"
    },
    {
      "id": "custom_342b0546-77c0-47b5-bbcf-24ae0b2ac10d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165606",
      "source": "custom",
      "poi_name": "Concourse East",
      "poi_type": "Transportation & Transit",
      "poi_address": "6725 Convair Rd, El Paso, TX 79925, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165606/019d2709-83e0-705d-97f3-c7c3d5985f82.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-83e0-705d-97f3-c7c3d5985f82",
        "storage_key": "property/6767906449165606/019d2709-83e0-705d-97f3-c7c3d5985f82.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=10886375157866865864&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "concourse-east",
      "poi_latitude": "31.79992469999999",
      "poi_longitude": "-106.3949994",
      "poi_miles_from_property": "3.2",
      "poi_walking_minutes": "1 hour 13 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165606/019d2709-97b1-72ff-99ec-34c3d7d0ef43.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-97b1-72ff-99ec-34c3d7d0ef43",
        "storage_key": "property/6767906449165606/019d2709-97b1-72ff-99ec-34c3d7d0ef43.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJcbkIwF9a54YRyKRKEIcsFJc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "airport"
    },
    {
      "id": "custom_e99ec4ea-0d33-43f9-a8dd-8e8e0cb314a3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165606",
      "source": "custom",
      "poi_name": "Concourse West",
      "poi_type": "Transportation & Transit",
      "poi_address": "El Paso, TX 79925, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165606/019d2709-853b-7278-a0ec-668e7b1beea3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-853b-7278-a0ec-668e7b1beea3",
        "storage_key": "property/6767906449165606/019d2709-853b-7278-a0ec-668e7b1beea3.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=17291459108056858109&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "concourse-west",
      "poi_latitude": "31.7999686",
      "poi_longitude": "-106.3963419",
      "poi_miles_from_property": "3.2",
      "poi_walking_minutes": "1 hour 13 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165606/019d2709-97b1-72ff-99ec-34c3d7d0ef43.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-97b1-72ff-99ec-34c3d7d0ef43",
        "storage_key": "property/6767906449165606/019d2709-97b1-72ff-99ec-34c3d7d0ef43.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJ-QA_y19a54YR_f3r13Ga9-8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "airport"
    },
    {
      "id": "custom_613e06d2-ec4d-4935-aecd-a2aef3ee2b55",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165606",
      "source": "custom",
      "poi_name": "Hawkins Elementary School",
      "poi_type": "Education",
      "poi_address": "5816 Stephenson Ave, El Paso, TX 79905, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://hawkins.episd.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4717542207952107076&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "hawkins-elementary-school",
      "poi_latitude": "31.7775096",
      "poi_longitude": "-106.4190554",
      "poi_miles_from_property": "4.1",
      "poi_walking_minutes": "1 hour 29 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 915-236-8900",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165606/019cfb40-e37c-7138-aeef-7f451bad9818.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb40-e37c-7138-aeef-7f451bad9818",
        "storage_key": "property/6767906449165606/019cfb40-e37c-7138-aeef-7f451bad9818.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJL2AlGjVa54YRRLblvaQTeEE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_a6ca162d-02ae-43eb-8423-88968b54ba95",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165606",
      "source": "custom",
      "poi_name": "Ramona Elementary School",
      "poi_type": "Education",
      "poi_address": "7755 Franklin Dr, El Paso, TX 79915, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165606/019d7912-3d74-71ca-80d1-cf8d3fea537c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-3d74-71ca-80d1-cf8d3fea537c",
        "storage_key": "property/6767906449165606/019d7912-3d74-71ca-80d1-cf8d3fea537c.webp",
        "width": 600,
        "height": 400
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=17745081018569052402&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "ramona-elementary-school",
      "poi_latitude": "31.7383804",
      "poi_longitude": "-106.3647994",
      "poi_miles_from_property": "2.8",
      "poi_walking_minutes": "1 hour 0 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 915-434-6900",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165606/019cfb40-e37c-7138-aeef-7f451bad9818.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb40-e37c-7138-aeef-7f451bad9818",
        "storage_key": "property/6767906449165606/019cfb40-e37c-7138-aeef-7f451bad9818.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ81vWBKVd54YR8tBVPisxQ_Y",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_c447aa34-51f5-480b-bc58-b95001015131",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165606",
      "source": "custom",
      "poi_name": "Bel Air Middle School",
      "poi_type": "Education",
      "poi_address": "7909 Ranchland Dr, El Paso, TX 79915, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165606/019d7912-3c9c-717c-9d1e-7252b9efc44d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-3c9c-717c-9d1e-7252b9efc44d",
        "storage_key": "property/6767906449165606/019d7912-3c9c-717c-9d1e-7252b9efc44d.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://belairmiddle.yisd.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15366217468377030351&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "bel-air-middle-school",
      "poi_latitude": "31.7515805",
      "poi_longitude": "-106.3497592",
      "poi_miles_from_property": "2.1",
      "poi_walking_minutes": "44 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 915-434-2200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165606/019cfb40-e37c-7138-aeef-7f451bad9818.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb40-e37c-7138-aeef-7f451bad9818",
        "storage_key": "property/6767906449165606/019cfb40-e37c-7138-aeef-7f451bad9818.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJTzJdOFFD54YRz94DsF_FP9U",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_7216cab8-d1a9-4743-aac3-f041b846cbd8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165606",
      "source": "custom",
      "poi_name": "Eastwood Middle School",
      "poi_type": "Education",
      "poi_address": "2612 Chaswood St, El Paso, TX 79935, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://www.yisd.net/eastwoodmiddle",
      "poi_directions_map_url": "https://maps.google.com/?cid=9135252933751608804&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "eastwood-middle-school",
      "poi_latitude": "31.7785968",
      "poi_longitude": "-106.3358678",
      "poi_miles_from_property": "2.3",
      "poi_walking_minutes": "50 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 915-434-4300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165606/019cfb40-e37c-7138-aeef-7f451bad9818.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb40-e37c-7138-aeef-7f451bad9818",
        "storage_key": "property/6767906449165606/019cfb40-e37c-7138-aeef-7f451bad9818.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ_2pBdtBE54YR5BWcgSTwxn4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_723666b0-1d0e-4054-8e40-74cd07d02fb9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165606",
      "source": "custom",
      "poi_name": "Silva Magnet High School",
      "poi_type": "Education",
      "poi_address": "121 Val Verde St EPISD, El Paso, TX 79905, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://silva.episd.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7873586719222167734&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "silva-magnet-high-school",
      "poi_latitude": "31.7690451",
      "poi_longitude": "-106.4331483",
      "poi_miles_from_property": "5.1",
      "poi_walking_minutes": "1 hour 53 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 915-236-7600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165606/019cfb40-e37c-7138-aeef-7f451bad9818.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb40-e37c-7138-aeef-7f451bad9818",
        "storage_key": "property/6767906449165606/019cfb40-e37c-7138-aeef-7f451bad9818.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJHZCZxNNb54YRtnh4s2eZRG0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "custom_7021b785-d528-40d0-adf7-d7168ba11941",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165606",
      "source": "custom",
      "poi_name": "Valle Verde Early College High School",
      "poi_type": "Education",
      "poi_address": "919 Hunter Dr, El Paso, TX 79915, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=8871166899539443026&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "valle-verde-early-college-high-school",
      "poi_latitude": "31.7530671",
      "poi_longitude": "-106.3657377",
      "poi_miles_from_property": "1.7",
      "poi_walking_minutes": "36 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 915-434-1500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165606/019cfb40-e37c-7138-aeef-7f451bad9818.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb40-e37c-7138-aeef-7f451bad9818",
        "storage_key": "property/6767906449165606/019cfb40-e37c-7138-aeef-7f451bad9818.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJXfJhI0Nb54YRUn1ALku3HHs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "custom_d1970a54-356e-40ce-9c91-b4a126dd8366",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165606",
      "source": "custom",
      "poi_name": "Southwest University",
      "poi_type": "Education",
      "poi_address": "6101 Montana Ave, El Paso, TX 79925, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165606/019d7912-47cf-74dd-927c-4745a2db27a3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-47cf-74dd-927c-4745a2db27a3",
        "storage_key": "property/6767906449165606/019d7912-47cf-74dd-927c-4745a2db27a3.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://southwestuniversity.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14473700373045968209&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "southwest-university",
      "poi_latitude": "31.7881511",
      "poi_longitude": "-106.413014",
      "poi_miles_from_property": "3.7",
      "poi_walking_minutes": "1 hour 25 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 915-778-4001",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165606/019cfb40-e37c-7138-aeef-7f451bad9818.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb40-e37c-7138-aeef-7f451bad9818",
        "storage_key": "property/6767906449165606/019cfb40-e37c-7138-aeef-7f451bad9818.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJn5KGL0Za54YRUf3X6M3p3Mg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_16e10668-6d88-42c9-87a7-de9b3c41447d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165606",
      "source": "custom",
      "poi_name": "Melting Pot",
      "poi_type": "Restaurants",
      "poi_address": "8889 Gateway Blvd W #2320, El Paso, TX 79925, USA",
      "poi_short_description": "Fondue restaurant chain offering heated pots of cheese, chocolate or broth for dipping & cooking.",
      "poi_long_description": "People say this fondue restaurant offers a delicious four-course meal and a delightful chocolate fondue dessert. They highlight the fun and unique dining experience, and the cozy and lovely atmosphere. They also like the attentive, friendly, and knowledgeable service.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165606/019d7912-3f86-7439-8db7-2b41f4194939.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-3f86-7439-8db7-2b41f4194939",
        "storage_key": "property/6767906449165606/019d7912-3f86-7439-8db7-2b41f4194939.webp",
        "width": 1280,
        "height": 622
      },
      "poi_business_url": "https://www.meltingpot.com/el-paso-tx/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16469071210319619810&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "melting-pot",
      "poi_latitude": "31.7704739",
      "poi_longitude": "-106.3735607",
      "poi_miles_from_property": "0.9",
      "poi_walking_minutes": "21 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 915-206-4647",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165606/019cfb40-e377-716e-b439-3825a72cde3a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb40-e377-716e-b439-3825a72cde3a",
        "storage_key": "property/6767906449165606/019cfb40-e377-716e-b439-3825a72cde3a.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJf5pvVuFb54YR4qa2RwLljeQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fondue_restaurant"
    },
    {
      "id": "custom_198b941e-3e64-4840-8b79-92488efb9574",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165606",
      "source": "custom",
      "poi_name": "National Car Rental",
      "poi_type": "Restaurants",
      "poi_address": "6505 Convair Rd Suite 430, El Paso, TX 79925, USA",
      "poi_short_description": "Car rental company with an in-airport location letting customers choose their own vehicles.",
      "poi_long_description": "People say this car rental agency offers clean, comfortable, and well-serviced vehicles. They also highlight the friendly, prompt, and courteous service, and the convenient airport location.\n\nOther reviews mention reservations can be unreliable.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165606/019d7912-4717-77c0-a546-d356dd2b2945.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-4717-77c0-a546-d356dd2b2945",
        "storage_key": "property/6767906449165606/019d7912-4717-77c0-a546-d356dd2b2945.webp",
        "width": 1280,
        "height": 1280
      },
      "poi_business_url": "https://www.nationalcar.com/en/car-rental-locations/us/tx/el-paso-international-airport-34l2.html?mcid=yext:245709",
      "poi_directions_map_url": "https://maps.google.com/?cid=12984595087597610248&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "national-car-rental",
      "poi_latitude": "31.7990656",
      "poi_longitude": "-106.396416",
      "poi_miles_from_property": "3.3",
      "poi_walking_minutes": "1 hour 15 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 833-659-1915",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165606/019cfb40-e378-779b-bac4-b388c8be5e30.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb40-e378-779b-bac4-b388c8be5e30",
        "storage_key": "property/6767906449165606/019cfb40-e378-779b-bac4-b388c8be5e30.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJZXDOrV9a54YRCKWJ1G-MMrQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "car_rental"
    },
    {
      "id": "custom_46d8db62-9d4e-4655-ae15-cb4d96de7ea8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165606",
      "source": "custom",
      "poi_name": "Andale Mexican Restaurant and Cantina",
      "poi_type": "Restaurants",
      "poi_address": "9201 Gateway Blvd W, El Paso, TX 79925, USA",
      "poi_short_description": "Traditional dishes & creative cocktails served in a festive atmosphere with live music nights.",
      "poi_long_description": "People say this Mexican restaurant serves delicious tacos, enchiladas, and guacamole. They also highlight the festive atmosphere with live mariachi music and the excellent service.\n\nOther reviews mention the food can be overcooked.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165606/019d7912-47bc-76dd-b061-f3e367ee7fd6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-47bc-76dd-b061-f3e367ee7fd6",
        "storage_key": "property/6767906449165606/019d7912-47bc-76dd-b061-f3e367ee7fd6.webp",
        "width": 1125,
        "height": 656
      },
      "poi_business_url": "http://www.andalemexicanrestaurant.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9586712556564435642&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "andale-mexican-restaurant-and-cantina",
      "poi_latitude": "31.7658402",
      "poi_longitude": "-106.3651468",
      "poi_miles_from_property": "0.6",
      "poi_walking_minutes": "12 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 915-590-5999",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165606/019cfb40-e377-716e-b439-3825a72cde3a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb40-e377-716e-b439-3825a72cde3a",
        "storage_key": "property/6767906449165606/019cfb40-e377-716e-b439-3825a72cde3a.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJIxHclz5b54YRutLMEUfYCoU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mexican_restaurant"
    },
    {
      "id": "custom_8e41ae1c-f59c-47d1-91a2-36cdd7d39548",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165606",
      "source": "custom",
      "poi_name": "The Place",
      "poi_type": "Restaurants",
      "poi_address": "821 N Copia St A, El Paso, TX 79903, USA",
      "poi_short_description": "Local, homey space showcasing tacos, gorditas, enchiladas and other familiar Mexican dishes such as menudo.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165606/019d7912-50dc-74bd-aad0-d6ca3d697d7b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-50dc-74bd-aad0-d6ca3d697d7b",
        "storage_key": "property/6767906449165606/019d7912-50dc-74bd-aad0-d6ca3d697d7b.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=1924688390160061277&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "the-place",
      "poi_latitude": "31.781887",
      "poi_longitude": "-106.4513937",
      "poi_miles_from_property": "6",
      "poi_walking_minutes": "2 hours 12 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 915-564-9125",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165606/019cfb40-e377-716e-b439-3825a72cde3a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb40-e377-716e-b439-3825a72cde3a",
        "storage_key": "property/6767906449165606/019cfb40-e377-716e-b439-3825a72cde3a.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ60J8Q4VZ54YRXRPPtuTdtRo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mexican_restaurant"
    },
    {
      "id": "custom_22166ed6-dbd4-4ec2-81b6-d0b0550956a0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165606",
      "source": "custom",
      "poi_name": "El Cometa",
      "poi_type": "Restaurants",
      "poi_address": "9529 Viscount Blvd, El Paso, TX 79925, USA",
      "poi_short_description": "Popular Mexican eatery in an airy, vibrant setting offering classic, familiar chow & a salsa bar.",
      "poi_long_description": "Diners say this Mexican restaurant serves delicious flautas, tacos, and horchata. They also highlight the friendly staff, reasonable prices, and generous portions.\n\nSome reviews mention the service can be slow.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165606/019d7912-573b-742e-8491-49570dddd436.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-573b-742e-8491-49570dddd436",
        "storage_key": "property/6767906449165606/019d7912-573b-742e-8491-49570dddd436.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.elcometaelpaso.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12753592693792184665&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "el-cometa",
      "poi_latitude": "31.7648366",
      "poi_longitude": "-106.3634273",
      "poi_miles_from_property": "0.6",
      "poi_walking_minutes": "12 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 915-594-7686",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165606/019cfb40-e377-716e-b439-3825a72cde3a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb40-e377-716e-b439-3825a72cde3a",
        "storage_key": "property/6767906449165606/019cfb40-e377-716e-b439-3825a72cde3a.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJyau3Ozlb54YRWRmAy_vc_bA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mexican_restaurant"
    },
    {
      "id": "custom_68947b22-c28b-487f-8ed8-a6c01385b234",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165606",
      "source": "custom",
      "poi_name": "West Texas Chophouse",
      "poi_type": "Restaurants",
      "poi_address": "1135 Airway Blvd Suite B, El Paso, TX 79925, USA",
      "poi_short_description": "Warm steakhouse with contemporary decor, offering prime meats, burgers & seafood options.",
      "poi_long_description": "Diners say this steakhouse serves up delicious bone marrow, poblano soup, and ribeye steak, and they praise the great prices and excellent service. They also highlight the elegant and romantic atmosphere, perfect for a special dinner.\n\nSome reviews mention the baked potatoes can be cold.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165606/019d7912-5777-74f3-9b78-3a167e3f3e3e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-5777-74f3-9b78-3a167e3f3e3e",
        "storage_key": "property/6767906449165606/019d7912-5777-74f3-9b78-3a167e3f3e3e.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.westtexaschophouse.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3633276246567992044&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "west-texas-chophouse",
      "poi_latitude": "31.7810648",
      "poi_longitude": "-106.3928371",
      "poi_miles_from_property": "2.2",
      "poi_walking_minutes": "49 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 915-775-2467",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165606/019cfb40-e377-716e-b439-3825a72cde3a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb40-e377-716e-b439-3825a72cde3a",
        "storage_key": "property/6767906449165606/019cfb40-e377-716e-b439-3825a72cde3a.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJLRSVjf9a54YR7LqMD3_9azI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "steak_house"
    },
    {
      "id": "custom_1228f97d-7d85-4f8a-b6b5-dac473e95ca9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165606",
      "source": "custom",
      "poi_name": "Pho Tre Bien",
      "poi_type": "Restaurants",
      "poi_address": "6946 Gtwy Blvd E, El Paso, TX 79915, USA",
      "poi_short_description": "Casual restaurant offering traditional Vietnamese dishes & sandwiches, plus Thai & bubble teas.",
      "poi_long_description": "People say this Vietnamese restaurant serves delicious pho, vermicelli, and egg rolls. They also highlight the good prices, chill vibe, and friendly service.\n\nSome reviews mention the service can be slow.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165606/019d7912-5d14-73e8-b238-936485faa350.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-5d14-73e8-b238-936485faa350",
        "storage_key": "property/6767906449165606/019d7912-5d14-73e8-b238-936485faa350.webp",
        "width": 1280,
        "height": 857
      },
      "poi_business_url": "http://www.photrebien.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5287091623677505157&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "pho-tre-bien",
      "poi_latitude": "31.77309",
      "poi_longitude": "-106.3823088",
      "poi_miles_from_property": "1.8",
      "poi_walking_minutes": "39 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 915-598-0166",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165606/019cfb40-e377-716e-b439-3825a72cde3a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb40-e377-716e-b439-3825a72cde3a",
        "storage_key": "property/6767906449165606/019cfb40-e377-716e-b439-3825a72cde3a.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ-8990ARb54YRha49zNGFX0k",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "vietnamese_restaurant"
    },
    {
      "id": "custom_8b891405-027c-4d9c-89d8-0686480ab16a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165606",
      "source": "custom",
      "poi_name": "Pepe's Tamales",
      "poi_type": "Restaurants",
      "poi_address": "9530 Viscount Blvd, El Paso, TX 79925, USA",
      "poi_short_description": "Tamale shop offering a variety of flavors, plus barbacoa, menudo, and champurrado on Saturdays and Sundays.",
      "poi_long_description": "People say this Mexican restaurant serves delicious tamales, menudo, and champurrado. They also highlight the friendly and polite service.\n\nOther reviews mention the tamales can be dry.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165606/019d7912-60be-72bc-b6de-f5fccedcbdd5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-60be-72bc-b6de-f5fccedcbdd5",
        "storage_key": "property/6767906449165606/019d7912-60be-72bc-b6de-f5fccedcbdd5.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=4841530584754860337&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "pepe-s-tamales",
      "poi_latitude": "31.7653602",
      "poi_longitude": "-106.3641048",
      "poi_miles_from_property": "0.6",
      "poi_walking_minutes": "12 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 915-591-7949",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165606/019cfb40-e377-716e-b439-3825a72cde3a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb40-e377-716e-b439-3825a72cde3a",
        "storage_key": "property/6767906449165606/019cfb40-e377-716e-b439-3825a72cde3a.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJxxQR00lb54YRMbGAUWqSMEM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mexican_restaurant"
    },
    {
      "id": "custom_5dac20fc-4ff6-4dce-8fce-0cfd802e19cd",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165606",
      "source": "custom",
      "poi_name": "The Fountains at Farah",
      "poi_type": "Shopping & Retail",
      "poi_address": "8889 Gateway Blvd W, El Paso, TX 79925, USA",
      "poi_short_description": "Outdoor retail complex with stores & restaurants set in a landscaped space with a performance stage.",
      "poi_long_description": "People say this shopping center offers a wide variety of shops and dining options. They highlight the enjoyable strolling experience with places to sit and relax, and the clean and well-maintained environment. They also like the different attractions throughout the year, such as ice skating in winter.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165606/019d7912-6924-7479-b23c-b473c1906496.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-6924-7479-b23c-b473c1906496",
        "storage_key": "property/6767906449165606/019d7912-6924-7479-b23c-b473c1906496.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.fountainsatfarah.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14551747413321332582&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "the-fountains-at-farah",
      "poi_latitude": "31.7686872",
      "poi_longitude": "-106.3701228",
      "poi_miles_from_property": "1.1",
      "poi_walking_minutes": "24 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 915-225-3600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165606/019cfb40-e386-73e3-ad94-66963eed2620.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb40-e386-73e3-ad94-66963eed2620",
        "storage_key": "property/6767906449165606/019cfb40-e386-73e3-ad94-66963eed2620.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJHR5ljhdb54YRZjc6iCwx8sk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_32917525-5d2c-4ba2-95b2-b74411f3738f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165606",
      "source": "custom",
      "poi_name": "Vista Del Valle Park",
      "poi_type": "Shopping & Retail",
      "poi_address": "1300 Hawkins Blvd, El Paso, TX 79925, USA",
      "poi_short_description": "Relaxed park with a playground and a basketball court. Friendly locals.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165606/019d7912-70c4-760c-b7e7-0d64234a852a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-70c4-760c-b7e7-0d64234a852a",
        "storage_key": "property/6767906449165606/019d7912-70c4-760c-b7e7-0d64234a852a.webp",
        "width": 964,
        "height": 1280
      },
      "poi_business_url": "https://www.elpasotexas.gov/parks-and-recreation",
      "poi_directions_map_url": "https://maps.google.com/?cid=16955857697993888934&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "vista-del-valle-park",
      "poi_latitude": "31.7771008",
      "poi_longitude": "-106.3695577",
      "poi_miles_from_property": "0.7",
      "poi_walking_minutes": "16 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 915-212-0092",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165606/019cfb40-e37c-7138-aeef-7b268c657f02.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb40-e37c-7138-aeef-7b268c657f02",
        "storage_key": "property/6767906449165606/019cfb40-e37c-7138-aeef-7b268c657f02.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJYRH2TB9b54YRppT_hr1OT-s",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_e0b17c29-0dc9-479d-bc94-d618fd60ba9e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165606",
      "source": "custom",
      "poi_name": "Bowl El Paso",
      "poi_type": "Shopping & Retail",
      "poi_address": "11144 Pellicano Dr, El Paso, TX 79935, USA",
      "poi_short_description": "Bowling alley featuring leagues & kids' bumper bowling, plus pool tables, a sports bar & a disco.",
      "poi_long_description": "People say this bowling alley offers fun bowling lanes and a lively atmosphere with live music and a bar.\n\nOther reviews mention the lanes can be poorly maintained and the service can be slow.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165606/019d7912-6e5f-720c-85ed-7d750951d75c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-6e5f-720c-85ed-7d750951d75c",
        "storage_key": "property/6767906449165606/019d7912-6e5f-720c-85ed-7d750951d75c.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://bowl-elpaso.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14370908349285614653&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "bowl-el-paso",
      "poi_latitude": "31.7482118",
      "poi_longitude": "-106.3247306",
      "poi_miles_from_property": "3.4",
      "poi_walking_minutes": "1 hour 16 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 915-593-7777",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165606/019cfb40-e378-779b-bac4-b388c8be5e30.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb40-e378-779b-bac4-b388c8be5e30",
        "storage_key": "property/6767906449165606/019cfb40-e378-779b-bac4-b388c8be5e30.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJobaNlqFE54YRPUTd2gC5b8c",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bowling_alley"
    },
    {
      "id": "custom_1811c887-6530-4986-9a23-70f96e5fadb4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165606",
      "source": "custom",
      "poi_name": "Speaking Rock Entertainment Center",
      "poi_type": "Shopping & Retail",
      "poi_address": "122 S Old Pueblo Rd, El Paso, TX 79907, USA",
      "poi_short_description": "Big casual complex offering concerts & a casino, plus a video game room, a restaurant & a bar.",
      "poi_long_description": "People say this casino offers a wide variety of slot machines, live music, and concerts. They also highlight the fun atmosphere, good food, and friendly staff.\n\nSome reviews mention there can be intense smoke.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165606/019d7912-76ab-77da-b415-eedf589dfcaa.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-76ab-77da-b415-eedf589dfcaa",
        "storage_key": "property/6767906449165606/019d7912-76ab-77da-b415-eedf589dfcaa.webp",
        "width": 748,
        "height": 500
      },
      "poi_business_url": "http://www.speakingrock.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4653660889167854766&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "speaking-rock-entertainment-center",
      "poi_latitude": "31.690126",
      "poi_longitude": "-106.326605",
      "poi_miles_from_property": "6.9",
      "poi_walking_minutes": "2 hours 30 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 915-860-7777",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165606/019cfb40-e378-779b-bac4-b388c8be5e30.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb40-e378-779b-bac4-b388c8be5e30",
        "storage_key": "property/6767906449165606/019cfb40-e378-779b-bac4-b388c8be5e30.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJAWub-dxC54YRrnz6K-wflUA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "casino"
    },
    {
      "id": "custom_4cd92b9e-e655-47cd-a84e-ecfd930f8b10",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165606",
      "source": "custom",
      "poi_name": "Cinemark Tinseltown Las Palmas XD and SCREENX",
      "poi_type": "Shopping & Retail",
      "poi_address": "11855 Gateway Blvd W, El Paso, TX 79936, USA",
      "poi_short_description": "Chain of movie theaters, some with multiple screens, stadium seats & self-service ticketing kiosks.",
      "poi_long_description": "People say this movie theater offers a wide selection of movies, including summer movies for kids, and comfortable, reclining seats. They highlight the clean and well-maintained venue, and the fresh popcorn with free refills. They also like the friendly and helpful staff, and the efficient service, especially when purchasing tickets and concessions online.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165606/019d7912-7b0f-71d1-afd4-6eeb4d32dc3b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-7b0f-71d1-afd4-6eeb4d32dc3b",
        "storage_key": "property/6767906449165606/019d7912-7b0f-71d1-afd4-6eeb4d32dc3b.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.cinemark.com/theatres/tx-el-paso/cinemark-tinseltown-las-palmas-xd-and-screenx?utm_medium=organic&utm_source=gmb&utm_campaign=local_listing_theater&utm_content=GMB_listing&y_source=1_MTc0OTI4NzUtNzE1LWxvY2F0aW9uLndlYnNpdGU%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=12027790687823146069&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "cinemark-tinseltown-las-palmas-xd-and-screenx",
      "poi_latitude": "31.7279597",
      "poi_longitude": "-106.3074884",
      "poi_miles_from_property": "5",
      "poi_walking_minutes": "1 hour 52 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 915-590-4676",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165606/019d7912-9beb-7717-899e-07b5f279979e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d7912-9beb-7717-899e-07b5f279979e",
        "storage_key": "property/6767906449165606/019d7912-9beb-7717-899e-07b5f279979e.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJW6YQrnND54YRVSxzlOdL66Y",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "movie_theater"
    },
    {
      "id": "custom_ea5f9486-f437-462b-bd26-78a9c528ef5c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165606",
      "source": "custom",
      "poi_name": "Ascarate Park Pool & Aquatics",
      "poi_type": "Shopping & Retail",
      "poi_address": "6900 Delta Dr, El Paso, TX 79905, USA",
      "poi_short_description": "Huge outdoor public pool open seasonally for swimming, diving, and chilling.",
      "poi_long_description": "People say this outdoor swimming pool offers a large pool with varying depths, a children's pool, and a ninja warrior course. They also highlight the park's all-abilities park, sitting areas, and opportunities for fishing and picnicking.\n\nOther reviews mention the hours can be inaccurate.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165606/019d7912-7c98-7666-aaa1-671b2a2471d7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-7c98-7666-aaa1-671b2a2471d7",
        "storage_key": "property/6767906449165606/019d7912-7c98-7666-aaa1-671b2a2471d7.webp",
        "width": 1280,
        "height": 515
      },
      "poi_business_url": "https://www.epcountyparks.com/ascarate-pool",
      "poi_directions_map_url": "https://maps.google.com/?cid=12124686360001813446&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "ascarate-park-pool-aquatics",
      "poi_latitude": "31.7558416",
      "poi_longitude": "-106.4040658",
      "poi_miles_from_property": "4.1",
      "poi_walking_minutes": "1 hour 30 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 915-273-3501",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165606/019cfb40-e378-779b-bac4-b388c8be5e30.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb40-e378-779b-bac4-b388c8be5e30",
        "storage_key": "property/6767906449165606/019cfb40-e378-779b-bac4-b388c8be5e30.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJrU2-oKJb54YRxpvuTAGKQ6g",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "swimming_pool"
    },
    {
      "id": "custom_f22eca3f-25c6-4a57-9cf1-3b21d2088efa",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165606",
      "source": "custom",
      "poi_name": "Red Door Escape Room",
      "poi_type": "Shopping & Retail",
      "poi_address": "8889 Gateway Blvd W Ste 2800, El Paso, TX 79925, USA",
      "poi_short_description": "Escape room center featuring various themed rooms with different levels of difficulty, designed for a variety of group sizes.",
      "poi_long_description": "People say this escape room center offers fun and challenging puzzles in well-designed rooms. They highlight the enjoyable experience and the attention to detail in the rooms. They also like the friendly and helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165606/019d7912-81c4-7126-83e2-f5134b540700.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-81c4-7126-83e2-f5134b540700",
        "storage_key": "property/6767906449165606/019d7912-81c4-7126-83e2-f5134b540700.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://reddoorescape.com/escape-rooms/el-paso/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3210948473621704831&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "red-door-escape-room",
      "poi_latitude": "31.7715684",
      "poi_longitude": "-106.3741514",
      "poi_miles_from_property": "0.9",
      "poi_walking_minutes": "21 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 915-283-4247",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165606/019cfb40-e378-779b-bac4-b388c8be5e30.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb40-e378-779b-bac4-b388c8be5e30",
        "storage_key": "property/6767906449165606/019cfb40-e378-779b-bac4-b388c8be5e30.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJrSvwszZb54YRf_BN2p-Ujyw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "amusement_center"
    },
    {
      "id": "custom_e8cfc991-f4bd-417b-a694-44bffc708112",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165606",
      "source": "custom",
      "poi_name": "Chamizal National Memorial Cultural Center",
      "poi_type": "Shopping & Retail",
      "poi_address": "800 S San Marcial St, El Paso, TX 79905, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165606/019d7912-87f6-726d-adcb-29092b5b5f99.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-87f6-726d-adcb-29092b5b5f99",
        "storage_key": "property/6767906449165606/019d7912-87f6-726d-adcb-29092b5b5f99.webp",
        "width": 720,
        "height": 1280
      },
      "poi_business_url": "https://www.nps.gov/cham/index.htm",
      "poi_directions_map_url": "https://maps.google.com/?cid=9078877620462599978&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "chamizal-national-memorial-cultural-center",
      "poi_latitude": "31.767946",
      "poi_longitude": "-106.4541147",
      "poi_miles_from_property": "7",
      "poi_walking_minutes": "2 hours 33 mins",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165606/019cfb40-e378-779b-bac4-b388c8be5e30.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb40-e378-779b-bac4-b388c8be5e30",
        "storage_key": "property/6767906449165606/019cfb40-e378-779b-bac4-b388c8be5e30.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJlSk8lWBZ54YRKr_qBhin_n0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "historical_landmark"
    },
    {
      "id": "custom_0cd86a1f-347f-4fe9-a4fe-90996bbbf8c6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165606",
      "source": "custom",
      "poi_name": "Lone Star Golf Club",
      "poi_type": "Shopping & Retail",
      "poi_address": "1510 Hawkins Blvd, El Paso, TX 79925, USA",
      "poi_short_description": "Golf club featuring a course with scenic views and a restaurant known for its tacos.",
      "poi_long_description": "People say this golf club offers a challenging course with wide fairways and a driving range. They also highlight the friendly and attentive staff, and the reasonable prices.\n\nOther reviews mention the greens can be poorly maintained.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165606/019d7912-87fb-76dd-b9a5-9fda2233fc56.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-87fb-76dd-b9a5-9fda2233fc56",
        "storage_key": "property/6767906449165606/019d7912-87fb-76dd-b9a5-9fda2233fc56.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://lonestargolfclub.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7594734153374505094&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "lone-star-golf-club",
      "poi_latitude": "31.7899012",
      "poi_longitude": "-106.3703897",
      "poi_miles_from_property": "1.7",
      "poi_walking_minutes": "39 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 915-591-4927",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165606/019cfb40-e378-779b-bac4-b388c8be5e30.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb40-e378-779b-bac4-b388c8be5e30",
        "storage_key": "property/6767906449165606/019cfb40-e378-779b-bac4-b388c8be5e30.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ8dCVReda54YRhhhqT3nqZWk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "sports_club"
    },
    {
      "id": "custom_5426652c-0a61-4f19-a132-79c33b728a4f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165606",
      "source": "custom",
      "poi_name": "Lincoln Park",
      "poi_type": "Shopping & Retail",
      "poi_address": "Lincoln Park, El Paso, TX, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165606/019d7912-9008-72de-86d8-e9023ddac3c3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-9008-72de-86d8-e9023ddac3c3",
        "storage_key": "property/6767906449165606/019d7912-9008-72de-86d8-e9023ddac3c3.webp",
        "width": 892,
        "height": 1280
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=16512316027616102450&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "lincoln-park",
      "poi_latitude": "31.7807646",
      "poi_longitude": "-106.432875",
      "poi_miles_from_property": "4.9",
      "poi_walking_minutes": "1 hour 48 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165606/019cfb40-e378-779b-bac4-b388c8be5e30.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb40-e378-779b-bac4-b388c8be5e30",
        "storage_key": "property/6767906449165606/019cfb40-e378-779b-bac4-b388c8be5e30.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJYUfEcy5a54YRMggM7fCHJ-U",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    }
  ],
  "office_hours": [
    {
      "id": "ec_64683583a0fed9c7f4f7bcae",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165606",
      "day": "MON",
      "open_time": "08:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_31ab8a0ebfbc399896e27835",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165606",
      "day": "TUE",
      "open_time": "08:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_acaab3b38f634ce4fb01f978",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165606",
      "day": "WED",
      "open_time": "08:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_46235fbcbb0b51b9c39e83f3",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165606",
      "day": "THU",
      "open_time": "08:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_af092b212e5649ea4ada0860",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165606",
      "day": "FRI",
      "open_time": "08:30",
      "close_time": "17:00"
    },
    {
      "id": "ec_2a1961dc1aa603c8456e0895",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165606",
      "day": "SAT",
      "open_time": "10:00",
      "close_time": "15:00"
    }
  ],
  "reviews": [
    {
      "id": "ec_3e2917eaf66c898394026703",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165606",
      "rating": "5",
      "name": "Lily Kim",
      "text": "I lived in this apartment for a year and I totally loved it!! Whenever I requested some work orders, they came and fixed right away and the leasing office staffs were really friendly especially Yvonne and Claudia! The location was also great. Close to everywhere such as Walmart, target or shopping mall! And when you do the inspection, they don't charge you unless there is a reason to charge.(you know some places just charge huge amount and even don't have proof) I tried to clean everything really hard before I left our apartment and It worthed it! They only charged me for the carpet shampooing cause I didn't do it. We moved out this apartment only because we had to move to DC. Now, If I come back to El paso, I know where to live!",
      "date": "2018-10-08",
      "title": "false"
    }
  ],
  "virtual_tours": [
    {
      "id": "custom_78d3caad-f538-4045-a255-5ec5a408a50c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165606",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165606/019cfb41-485f-77d9-89d9-d5560d29760d.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "360° view of an outdoor swimming pool with lounge chairs and palm trees.",
        "public_id": "019cfb41-485f-77d9-89d9-d5560d29760d",
        "storage_key": "property/6767906449165606/019cfb41-485f-77d9-89d9-d5560d29760d.webp",
        "width": 400,
        "height": 200
      },
      "virtual_tour_title": "High Ridge Virtual Tour",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://tour.tourbuilder.com/?tour=5f6d59ac267dbd0c25987694&sourceId=1001"
    }
  ],
  "faqs": [],
  "lead_collectors": [
    {
      "lead_collector_id": "019cf79e-35bc-777a-bdfe-0580584d0938",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "high-ridge-apts.",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165606"
    },
    {
      "lead_collector_id": "019cf79e-362e-70a9-9b21-ae8928578120",
      "lead_source": "LANDING_PAGE",
      "name": "high-ridge-apts.",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165606"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165606",
      "source": "generator",
      "page_item_url": "apartments-with-pool-in-el-paso-tx-high-ridge",
      "search_query": "apartments with pool in El Paso TX",
      "category": "Amenity",
      "h1_title": "Apartments with Pool in El Paso, TX",
      "h2_subtitle": "Discover vibrant apartments with a pool in El Paso, TX. High Ridge Apts. offers modern spaces with great amenities in a convenient location.",
      "page_copy": "Looking for apartments with a pool in El Paso, TX? High Ridge Apts. is your perfect match. Our community features a sparkling pool where you can unwind and soak up the sunny El Paso weather. With spacious one- and two-bedroom floor plans, you'll have plenty of room to relax and enjoy modern amenities like a fitness center and a picnic area, perfect for entertaining guests.\n\nNestled in the Stonehaven neighborhood, High Ridge Apts. provides easy access to major highways such as I-35, I-240, I-40, and I-44, making commuting a breeze. Plus, if you're stationed at Ft. Bliss, you'll appreciate the short commute. With amenities like a wet bar and built-in bookshelves in select units, you'll feel right at home. Don't wait—explore our availability or schedule a tour today!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165606/019cfb40-91f0-70ac-9a6e-8b87a857c9bf.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of apartment buildings with brick facades and balconies, surrounded by trees and landscaping.",
        "public_id": "019cfb40-91f0-70ac-9a6e-8b87a857c9bf",
        "storage_key": "property/6767906449165606/019cfb40-91f0-70ac-9a6e-8b87a857c9bf.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with Pool in El Paso, TX | High Ridge",
      "seo_description": "Explore High Ridge Apts in El Paso, TX. Enjoy a vibrant lifestyle with a pool, fitness center, and more. Ideal location near major highways and Ft. Bliss.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165606",
      "source": "generator",
      "page_item_url": "high-ridge-apts-pet-friendly-el-paso",
      "search_query": "High Ridge Apts pet friendly El Paso",
      "category": "Amenity",
      "h1_title": "High Ridge Apts: Pet Friendly Living",
      "h2_subtitle": "Welcome to High Ridge Apts, your pet friendly community in El Paso. Experience comfortable living with amenities perfect for you and your furry friend.",
      "page_copy": "At High Ridge Apts, we understand that pets are part of the family. That's why we're proud to offer pet friendly living in the heart of El Paso, TX. Our spacious one- and two-bedroom apartments provide the perfect setting for both you and your pets to thrive. Enjoy features like a sparkling pool, fitness center, and picnic area, all designed to enhance your lifestyle.\n\nLocated in the vibrant Stonehaven neighborhood, High Ridge Apts offers easy access to I-35, I-240, I-40, and I-44, simplifying your daily commute. Whether you're heading to work or exploring what El Paso has to offer, you'll love the convenience of our location. Plus, with attractions like Ft. Bliss nearby, there's always something to do with your pet by your side. Discover the perfect blend of comfort and convenience at High Ridge Apts today!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165606/019cfb40-91f0-70ac-9a6e-8b87a857c9bf.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of apartment buildings with brick facades and balconies, surrounded by trees and landscaping.",
        "public_id": "019cfb40-91f0-70ac-9a6e-8b87a857c9bf",
        "storage_key": "property/6767906449165606/019cfb40-91f0-70ac-9a6e-8b87a857c9bf.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "High Ridge Apts: Pet Friendly in El Paso, TX",
      "seo_description": "Discover High Ridge Apts in El Paso, a pet friendly community with spacious plans, modern amenities, and a convenient location. Perfect for you and your pet.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165606",
      "source": "generator",
      "page_item_url": "high-ridge-dishwasher-apartments-el-paso",
      "search_query": "High Ridge dishwasher apartments El Paso",
      "category": "Amenity",
      "h1_title": "High Ridge: Dishwasher Apartments in El Paso",
      "h2_subtitle": "Explore High Ridge Apts in El Paso for top-notch amenities, including modern dishwasher-equipped kitchens in each apartment.",
      "page_copy": "High Ridge Apts in El Paso offers the ideal blend of comfort and convenience with our dishwasher-equipped apartments. Whether you're hosting a dinner party or preparing a quiet meal at home, you'll appreciate the ease and efficiency provided by your modern kitchen amenities. Our spacious one- and two-bedroom floor plans are designed with you in mind, offering plenty of room to relax and enjoy.\n\nSituated in the lively Stonehaven neighborhood, High Ridge Apts provides not just fully-equipped kitchens, but also a range of amenities like a sparkling pool, fitness center, and picnic area. Plus, with our strategic location offering easy access to I-35, I-240, I-40, and I-44, commuting has never been easier. Experience a lifestyle packed with convenience and style at High Ridge Apts in El Paso, where every meal prep is a breeze!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165606/019cfb40-91f0-70ac-9a6e-8b87a857c9bf.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of apartment buildings with brick facades and balconies, surrounded by trees and landscaping.",
        "public_id": "019cfb40-91f0-70ac-9a6e-8b87a857c9bf",
        "storage_key": "property/6767906449165606/019cfb40-91f0-70ac-9a6e-8b87a857c9bf.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "High Ridge: Dishwasher Apartments in El Paso, TX",
      "seo_description": "Discover High Ridge Apts in El Paso featuring dishwasher-equipped homes and modern amenities. Enjoy convenient living with direct access to major highways.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165606",
      "source": "generator",
      "page_item_url": "air-conditioned-apartments-stonehaven-el-paso",
      "search_query": "air conditioned apartments in Stonehaven El Paso",
      "category": "Amenity",
      "h1_title": "Air Conditioned Apartments in Stonehaven, El Paso",
      "h2_subtitle": "Stay cool at High Ridge Apts, offering air conditioned living in Stonehaven, El Paso. Enjoy modern amenities in a comfortable setting.",
      "page_copy": "Stay comfortable year-round at High Ridge Apts, where our air conditioned apartments in Stonehaven, El Paso, offer a relaxing refuge from the Texas heat. Choose from spacious one- and two-bedroom floor plans, all equipped with efficient air conditioning systems that provide a welcoming, climate-controlled environment.\n\nLocated in the vibrant Stonehaven neighborhood, our community provides modern living with features such as a sparkling pool, fitness center, and a picnic area, perfect for unwinding or socializing with neighbors. With easy access to major highways including I-35, I-240, I-40, and I-44, commuting is straightforward, whether you are heading to work or off on a weekend adventure. Experience a perfect blend of comfort and convenience at High Ridge Apts today!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165606/019cfb40-91f0-70ac-9a6e-8b87a857c9bf.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of apartment buildings with brick facades and balconies, surrounded by trees and landscaping.",
        "public_id": "019cfb40-91f0-70ac-9a6e-8b87a857c9bf",
        "storage_key": "property/6767906449165606/019cfb40-91f0-70ac-9a6e-8b87a857c9bf.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Air Conditioned Apartments in Stonehaven, El Paso",
      "seo_description": "Enjoy air conditioned apartments at High Ridge in Stonehaven, El Paso. Modern amenities and convenient access to major highways await you.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165606",
      "source": "generator",
      "page_item_url": "in-unit-laundry-apartments-near-ft-bliss",
      "search_query": "in unit laundry apartments near Ft. Bliss",
      "category": "Amenity",
      "h1_title": "In-Unit Laundry Apartments Near Ft. Bliss",
      "h2_subtitle": "Discover High Ridge Apts near Ft. Bliss offering in-unit laundry. Enjoy the convenience of modern amenities in our El Paso community.",
      "page_copy": "High Ridge Apts provides the ultimate in convenience with our in-unit laundry apartments near Ft. Bliss. Say goodbye to tedious trips to the laundromat and hello to the ease of doing laundry in the comfort of your own home. Our spacious one- and two-bedroom residences are designed to make your life simpler, with every unit including top-notch amenities.\n\nLocated just a short drive from Ft. Bliss, High Ridge Apts features not only in-unit laundry but also modern facilities like a sparkling pool, fitness center, and picnic area. Our central placement in the Stonehaven neighborhood means you have easy access to major highways such as I-35, I-240, I-40, and I-44, allowing smooth commutes and quick trips around El Paso. Discover a harmonious blend of comfort and convenience at High Ridge Apts.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165606/019cfb40-91f0-70ac-9a6e-8b87a857c9bf.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of apartment buildings with brick facades and balconies, surrounded by trees and landscaping.",
        "public_id": "019cfb40-91f0-70ac-9a6e-8b87a857c9bf",
        "storage_key": "property/6767906449165606/019cfb40-91f0-70ac-9a6e-8b87a857c9bf.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "In-Unit Laundry Apartments Near Ft. Bliss, TX",
      "seo_description": "Find High Ridge Apts with in-unit laundry near Ft. Bliss. Experience modern comfort and easy access to El Paso's major highways.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165606",
      "source": "generator",
      "page_item_url": "1-bedroom-apartments-el-paso-tx",
      "search_query": "1 bedroom apartments el paso tx",
      "category": "Floorplan",
      "h1_title": "Comfortable 1 Bedroom Apartments in El Paso, TX",
      "h2_subtitle": "Discover the perfect 1-bedroom living at High Ridge Apts in El Paso, TX. Spacious layouts and modern amenities await you.",
      "page_copy": "High Ridge Apts invites you to experience premium living in our 1-bedroom apartments in El Paso, TX. Each residence is thoughtfully designed to maximize space and comfort, featuring a variety of modern amenities including efficient air conditioning, built-in bookshelves, and roomy layouts ideal for a cozy lifestyle.\n\nNestled in the vibrant Stonehaven neighborhood, High Ridge Apts offers more than just a home—it's a community complete with facilities like a sparkling pool, fitness center, and picnic area. Our location provides seamless access to major highways such as I-35, I-240, I-40, and I-44, making commuting across El Paso a breeze. Whether you're new to the city or looking for a change, High Ridge Apts is a gateway to an elevated living experience in El Paso.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165606/019cfb40-91f0-70ac-9a6e-8b87a857c9bf.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of apartment buildings with brick facades and balconies, surrounded by trees and landscaping.",
        "public_id": "019cfb40-91f0-70ac-9a6e-8b87a857c9bf",
        "storage_key": "property/6767906449165606/019cfb40-91f0-70ac-9a6e-8b87a857c9bf.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Comfortable 1 Bedroom Apartments in El Paso, TX",
      "seo_description": "Explore High Ridge's 1-bedroom apartments in El Paso, TX. Enjoy modern living with easy access to city's major roads and amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165606",
      "source": "generator",
      "page_item_url": "2-bedroom-apartments-stonehaven-el-paso",
      "search_query": "2 bedroom apartments stonehaven el paso",
      "category": "Floorplan",
      "h1_title": "Spacious 2 Bedroom Apartments in Stonehaven, El Paso",
      "h2_subtitle": "Explore the 2-bedroom apartments at High Ridge Apts in Stonehaven, El Paso. Roomy layouts and modern amenities await you.",
      "page_copy": "Discover the ideal home at High Ridge Apts with our spacious 2-bedroom apartments in Stonehaven, El Paso. Designed with modern living in mind, our floor plans offer abundant space and comfort, enhanced by features such as built-in bookshelves and efficient air conditioning.\n\nEnjoy the vibrant community amenities, including a sparkling pool, fitness center, and welcoming picnic area, perfect for gatherings or relaxation. Located in the heart of Stonehaven with easy access to major highways like I-35, I-240, I-40, and I-44, High Ridge Apts provides a balance of convenience and contemporary living. Whether you're sharing with a roommate or need extra space, our 2-bedroom apartments are poised to meet your every need.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165606/019cfb40-91f0-70ac-9a6e-8b87a857c9bf.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of apartment buildings with brick facades and balconies, surrounded by trees and landscaping.",
        "public_id": "019cfb40-91f0-70ac-9a6e-8b87a857c9bf",
        "storage_key": "property/6767906449165606/019cfb40-91f0-70ac-9a6e-8b87a857c9bf.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Spacious 2 Bedroom Apartments in Stonehaven, El Paso",
      "seo_description": "Find spacious 2-bedroom apartments at High Ridge in Stonehaven, El Paso. Enjoy modern living amenities with easy highway access.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_qb_id",
      "type": "STRING",
      "value": "5177"
    },
    {
      "ID": "custom_ga4_id",
      "type": "STRING",
      "value": "G-60CWMBBJK4"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "10041151926"
    },
    {
      "ID": "custom_tour24_url",
      "type": "STRING",
      "value": "https://app.tour24now.com/prospect/tour/high-ridge/register/"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-KDG7V2P9"
    },
    {
      "ID": "custom_floorplan_pdf_url",
      "type": "STRING",
      "value": "https://multihubmedia.com/property/6767906449165606/019d1bd8-3942-7295-aaf2-942f18fd20c8.pdf"
    },
    {
      "ID": "custom_hubspot_company_id",
      "type": "STRING",
      "value": "8443218215"
    },
    {
      "ID": "custom_ppc_tracking_phone_number",
      "type": "STRING",
      "value": "844-654-6599"
    },
    {
      "ID": "custom_residentboost_apartment_id",
      "type": "STRING",
      "value": "6480cd378b4d2861bc510114"
    },
    {
      "ID": "custom_apartmentsync_javascript_id",
      "type": "STRING",
      "value": "eyJpdiI6IjE4Z0psL3ppTXFYSUJYc3IyNDVkRVE9PSIsInZhbHVlIjoiT0dMWlJrSzdFd0JHVVk3cFR0QlRiZz09IiwibWFjIjoiYmY2YWQ2YjJiNmMxOWJhMWQzODIyMzdhZjQyYmZjZTIyNWZkNzBmNTk1NWU5Yzc1NjA0YzQ4OTY2YjNlMTE1NiJ9"
    }
  ],
  "custom_qb_id": "5177",
  "custom_ga4_id": "G-60CWMBBJK4",
  "custom_repli_id": "10041151926",
  "custom_tour24_url": "https://app.tour24now.com/prospect/tour/high-ridge/register/",
  "custom_google_gtm_id": "GTM-KDG7V2P9",
  "custom_floorplan_pdf_url": "https://multihubmedia.com/property/6767906449165606/019d1bd8-3942-7295-aaf2-942f18fd20c8.pdf",
  "custom_hubspot_company_id": "8443218215",
  "custom_ppc_tracking_phone_number": "844-654-6599",
  "custom_residentboost_apartment_id": "6480cd378b4d2861bc510114",
  "custom_apartmentsync_javascript_id": "eyJpdiI6IjE4Z0psL3ppTXFYSUJYc3IyNDVkRVE9PSIsInZhbHVlIjoiT0dMWlJrSzdFd0JHVVk3cFR0QlRiZz09IiwibWFjIjoiYmY2YWQ2YjJiNmMxOWJhMWQzODIyMzdhZjQyYmZjZTIyNWZkNzBmNTk1NWU5Yzc1NjA0YzQ4OTY2YjNlMTE1NiJ9"
};

export const generatedAt = '2026-08-27T21:38:01.750Z';
